export default {
  alert: {
    type: 'svg',
    attrs: {
      id: 'alert',
      viewBox: '0 0 49 49',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'alert-path-1',
          d: 'M24.5,49A24.5,24.5,0,1,1,49,24.5,24.528,24.528,0,0,1,24.5,49ZM22.05,31.849v4.9h4.9v-4.9Zm0-19.6v14.7h4.9v-14.7Z',
        },
      },
    ],
  },

  approve: {
    type: 'svg',
    attrs: {
      id: 'approve',
      viewBox: '0 0 32 32',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'approve-g-1',
          transform: 'translate(-314 -1174)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'approve-path-1',
              d: 'M327.333,1200.667a2,2,0,0,1-1.414-.586l-7.333-7.333a2,2,0,0,1,2.828-2.828l5.919,5.919,13.252-13.252a2,2,0,0,1,2.828,2.828l-14.667,14.667A2,2,0,0,1,327.333,1200.667Z',
            },
          },
        ],
      },
    ],
  },

  'approve-circle': {
    type: 'svg',
    attrs: {
      id: 'approve',
      viewBox: '0 0 48 48',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'approve-circle-g-1',
          transform: 'translate(-440 -1950)',
        },
        childs: [
          {
            type: 'g',
            attrs: {
              id: 'approve-circle-g-2',
              transform: 'translate(34 688)',
            },
            childs: [
              {
                type: 'circle',
                attrs: {
                  id: 'approve-circle-circle-1',
                  cx: '24',
                  cy: '24',
                  r: '24',
                  transform: 'translate(406 1262)',
                },
              },
              {
                type: 'path',
                attrs: {
                  id: 'approve-circle-path-1',
                  d: 'M427.333,1296.667a1.994,1.994,0,0,1-1.414-.586l-7.333-7.333a2,2,0,0,1,2.828-2.828l5.919,5.919,13.252-13.252a2,2,0,0,1,2.828,2.828l-14.667,14.667A1.994,1.994,0,0,1,427.333,1296.667Z',
                  fill: '#fff',
                },
              },
            ],
          },
        ],
      },
    ],
  },

  'arrow-back': {
    type: 'svg',
    attrs: {
      id: 'arrow-back',
      viewBox: '0 0 48 48',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'arrow-back-g-1',
          transform: 'translate(-112 -1272)',
        },
        childs: [
          {
            type: 'rect',
            attrs: {
              id: 'arrow-back-rect-1',
              d: 'translate(112 1272)',
              fill: 'none',
              width: '42',
              height: '42',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'arrow-back-path-1',
              d: 'M30.118,2H0A2,2,0,0,1-2,0,2,2,0,0,1,0-2H30.118a2,2,0,0,1,2,2A2,2,0,0,1,30.118,2Z',
              transform: 'translate(121.882 1296.549)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'arrow-back-path-2',
              d: 'M132.549,1311.1a1.994,1.994,0,0,1-1.414-.586l-12.549-12.549a2,2,0,0,1,0-2.828l12.549-12.549a2,2,0,0,1,2.828,2.828l-11.135,11.135,11.135,11.135a2,2,0,0,1-1.414,3.414Z',
            },
          },
        ],
      },
    ],
  },

  'arrow-down': {
    type: 'svg',
    attrs: {
      id: 'arrow-down',
      viewBox: '0 0 39 39',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'arrow-down-path-1',
          d: 'M.918,21.6l-.884-.884a1,1,0,0,1,0-1.415l8.485-8.485L.034,2.332a1,1,0,0,1,0-1.414L.918.034a1,1,0,0,1,1.415,0L12.409,10.11a1,1,0,0,1,0,1.415L2.333,21.6a1,1,0,0,1-1.415,0Z',
          transform: 'translate(30.596 13.277) rotate(90)',
        },
      },
    ],
  },

  'arrow-left': {
    type: 'svg',
    attrs: {
      id: 'arrow-left',
      viewBox: '0 0 39 39',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'arrow-left-path-1',
          d: 'M.918,21.6l-.885-.884a1,1,0,0,1,0-1.414l8.486-8.486L.034,2.332a1,1,0,0,1,0-1.415L.918.033a1,1,0,0,1,1.414,0L12.408,10.11a1,1,0,0,1,0,1.414L2.332,21.6a1,1,0,0,1-1.414,0Z',
          transform: 'translate(26 30.316) rotate(180)',
        },
      },
    ],
  },

  'arrow-right': {
    type: 'svg',
    attrs: {
      id: 'arrow-right',
      viewBox: '0 0 39 39',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'arrow-right-path-1',
          d: 'M.918,21.6l-.884-.884a1,1,0,0,1,0-1.415l8.485-8.485L.034,2.332a1,1,0,0,1,0-1.414L.918.034a1,1,0,0,1,1.414,0l9.189,9.189,0,0,.884.884a1,1,0,0,1,0,1.415l-.884.884L2.332,21.6a1,1,0,0,1-1.414,0Z',
          transform: 'translate(13.558 8.682)',
        },
      },
    ],
  },

  'arrow-up': {
    type: 'svg',
    attrs: {
      id: 'arrow-up',
      viewBox: '0 0 39 39',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'arrow-up-path-1',
          d: 'M.918,21.6l-.885-.884a1,1,0,0,1,0-1.414l8.486-8.486L.034,2.332a1,1,0,0,1,0-1.415L.918.033a1,1,0,0,1,1.414,0L12.408,10.11a1,1,0,0,1,0,1.414L2.332,21.6a1,1,0,0,1-1.414,0Z',
          transform: 'translate(8.962 25.72) rotate(-90)',
        },
      },
    ],
  },

  bookmark: {
    type: 'svg',
    attrs: {
      id: 'bookmark',
      viewBox: '0 0 23.664 30.425',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'bookmark-path-1',
          d: 'M20.283,0H3.381A3.391,3.391,0,0,0,0,3.381V30.425l11.832-5.071,11.832,5.071V3.381A3.391,3.391,0,0,0,20.283,0Z',
        },
      },
    ],
  },

  'buger-menu': {
    type: 'svg',
    attrs: {
      id: 'buger-menu',
      viewBox: '0 0 40 26',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'buger-menu-path-1',
          d: 'M40,26H0V21.667H40V26Zm0-10.833H0V10.834H40v4.333ZM40,4.333H0V0H40V4.333Z',
        },
      },
    ],
  },

  campaign: {
    type: 'svg',
    attrs: {
      id: 'campaign',
      viewBox: '0 0 49.431 49.431',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'campaign-path-1',
          d: 'M35.226,0H14.2A14.2,14.2,0,0,0,0,14.2V35.226a14.2,14.2,0,0,0,14.2,14.2H35.226a14.2,14.2,0,0,0,14.2-14.2V14.2A14.2,14.2,0,0,0,35.226,0ZM33.539,13.352c.955-.736,1.989-1.508,2.977-2.241a1.8,1.8,0,0,1,2.523.348l.014.018c0,.02.017.02.017.037a1.83,1.83,0,0,1-.349,2.537c-.974.736-2,1.526-2.977,2.241a1.8,1.8,0,0,1-2.52-.344l-.017-.023c0-.02-.017-.02-.017-.037a1.8,1.8,0,0,1,.329-2.522Zm-6.986,22.42L17.36,30.258H15.522v5.514a1.838,1.838,0,0,1-3.676,0V30.258H10.008a3.693,3.693,0,0,1-3.676-3.693V22.9a3.693,3.693,0,0,1,3.676-3.676H17.36l9.193-5.514Zm1.838-4.889v-12.3a8.238,8.238,0,0,1,0,12.3Zm10.662,7.057c0,.02-.02.02-.02.037a1.8,1.8,0,0,1-2.514.387l-.023-.017c-.974-.736-1.989-1.508-2.977-2.224a1.775,1.775,0,0,1-.4-2.479l.03-.04a.059.059,0,0,0,.017-.037,1.829,1.829,0,0,1,2.557-.386L38.684,35.4a1.8,1.8,0,0,1,.387,2.514Zm2.2-11.363H37.581a1.838,1.838,0,0,1,0-3.676h3.676a1.838,1.838,0,0,1,0,3.676Z',
        },
      },
    ],
  },

  'cast-off': {
    type: 'svg',
    attrs: {
      id: 'cast-off',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'cast-off-path-1',
          d: 'M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0ZM28.24,135.16v-16a16,16,0,0,1,16,16Zm31.57,0a5.33,5.33,0,0,1-5.24-4.54,26.79,26.79,0,0,0-21.79-21.79,5.35,5.35,0,0,1,1.55-10.58,37.38,37.38,0,0,1,30.82,30.83A5.36,5.36,0,0,1,59.81,135.16Zm21.58,0a5.24,5.24,0,0,1-5.29-4.65A48.06,48.06,0,0,0,32.94,87.3,5.27,5.27,0,0,1,28.24,82a5.39,5.39,0,0,1,5.88-5.34,58.86,58.86,0,0,1,52.61,52.5A5.38,5.38,0,0,1,81.39,135.11Zm64.36-10.63a10.7,10.7,0,0,1-10.68,10.68H103a5.34,5.34,0,1,1,0-10.68h26.71a5.35,5.35,0,0,0,5.34-5.34V55a5.35,5.35,0,0,0-5.34-5.34H44.26A5.36,5.36,0,0,0,38.92,55v5.34a5.34,5.34,0,1,1-10.68,0V49.7A10.72,10.72,0,0,1,38.92,39h96.15A10.71,10.71,0,0,1,145.75,49.7Z',
        },
      },
    ],
  },

  'cast-on': {
    type: 'svg',
    attrs: {
      id: 'cast-on',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'cast-on-path-1',
          d: 'M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0ZM28.24,135.16v-16a16,16,0,0,1,13.3,7,16.14,16.14,0,0,1,2.72,9Zm31.57,0a5.33,5.33,0,0,1-5.24-4.54,26.79,26.79,0,0,0-21.79-21.79,5.35,5.35,0,0,1,1.55-10.58,37.38,37.38,0,0,1,30.82,30.83A5.36,5.36,0,0,1,59.81,135.16Zm21.58,0a5.24,5.24,0,0,1-5.29-4.65A48.06,48.06,0,0,0,32.94,87.3,5.27,5.27,0,0,1,28.24,82a5.39,5.39,0,0,1,5.88-5.34,58.86,58.86,0,0,1,52.61,52.5A5.38,5.38,0,0,1,81.39,135.11Zm-31.78-66V65.73A5.36,5.36,0,0,1,55,60.38h64.1a5.37,5.37,0,0,1,5.34,5.35v42.73a5.36,5.36,0,0,1-5.34,5.34H94.31A69.61,69.61,0,0,0,49.61,69.09Zm96.14,55.39a10.7,10.7,0,0,1-10.68,10.68H103a5.34,5.34,0,1,1,0-10.68h26.71a5.35,5.35,0,0,0,5.34-5.34V55a5.35,5.35,0,0,0-5.34-5.34H44.26A5.36,5.36,0,0,0,38.92,55v5.34a5.34,5.34,0,1,1-10.68,0V49.7A10.72,10.72,0,0,1,38.92,39h96.15A10.71,10.71,0,0,1,145.75,49.7Z',
        },
      },
    ],
  },

  circle: {
    type: 'svg',
    attrs: {
      id: 'circle',
      viewBox: '0 0 34 34',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'circle-path-1',
          d: 'M17,34A17,17,0,1,1,34,17,17.019,17.019,0,0,1,17,34ZM17,3.4A13.6,13.6,0,1,0,30.6,17,13.616,13.616,0,0,0,17,3.4Z',
        },
      },
    ],
  },

  'circle-full': {
    type: 'svg',
    attrs: {
      id: 'circle-full',
      viewBox: '0 0 34 34',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'circle-full-path-1',
          d: 'M17,34A17,17,0,1,1,34,17,17.019,17.019,0,0,1,17,34ZM17,3.4A13.6,13.6,0,1,0,30.6,17,13.616,13.616,0,0,0,17,3.4Zm0,22.1A8.5,8.5,0,1,1,25.5,17,8.51,8.51,0,0,1,17,25.5Z',
        },
      },
    ],
  },

  clock: {
    type: 'svg',
    attrs: {
      id: 'clock',
      viewBox: '0 0 37.215 37.215',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'clock-path-1',
          transform: 'translate(-1.5 -1.5)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'clock-path-1',
              d: 'M20.107,38.715A18.612,18.612,0,0,1,12.864,2.963,18.612,18.612,0,0,1,27.351,37.252,18.492,18.492,0,0,1,20.107,38.715Zm0-34.215A15.607,15.607,0,0,0,9.071,31.144,15.607,15.607,0,1,0,31.144,9.071,15.505,15.505,0,0,0,20.107,4.5Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'clock-path-2',
              d: 'M24.842,24.186a1.494,1.494,0,0,1-.67-.159l-6.843-3.421a1.5,1.5,0,0,1-.829-1.342V9a1.5,1.5,0,0,1,3,0v9.337l6.014,3.007a1.5,1.5,0,0,1-.672,2.842Z',
              transform: 'translate(2.107 0.843)',
            },
          },
        ],
      },
    ],
  },

  close2: {
    type: 'svg',
    attrs: {
      id: 'close2',
      viewBox: '0 0 28 28',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'close2-g-1',
        },
        childs: [
          {
            type: 'rect',
            attrs: {
              id: 'close2-rect-1',
              width: '28',
              height: '28',
              fill: 'none',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'close2-path-1',
              d: 'M0,21.946a1.994,1.994,0,0,1-1.414-.586,2,2,0,0,1,0-2.828L18.532-1.414a2,2,0,0,1,2.828,0,2,2,0,0,1,0,2.828L1.414,21.36A1.994,1.994,0,0,1,0,21.946Z',
              transform: 'translate(4 4)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'close2-path-2',
              d: 'M19.946,21.946a1.994,1.994,0,0,1-1.414-.586L-1.414,1.414a2,2,0,0,1,0-2.828,2,2,0,0,1,2.828,0L21.36,18.532a2,2,0,0,1-1.414,3.414Z',
              transform: 'translate(4 4)',
            },
          },
        ],
      },
    ],
  },

  'close-circle': {
    type: 'svg',
    attrs: {
      id: 'close-circle',
      viewBox: '0 0 48 48',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'close-circle-path-1',
          d: 'M24,48A24.009,24.009,0,0,1,7.023,7.023,24.009,24.009,0,0,1,40.978,40.978,23.848,23.848,0,0,1,24,48Zm0-20.615,0,0L32.616,36,36,32.616,27.385,24,36,15.384,32.616,12,24,20.615,15.384,12,12,15.384,20.615,24,12,32.616,15.384,36,24,27.386Z',
        },
      },
    ],
  },

  copy: {
    type: 'svg',
    attrs: {
      id: 'copy',
      viewBox: '0 0 33 37',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'copy-path-1',
          d: 'M29.527,37H10.422a3.424,3.424,0,0,1-3.475-3.363V10.092a3.425,3.425,0,0,1,3.475-3.365H29.527A3.424,3.424,0,0,1,33,10.092V33.637A3.424,3.424,0,0,1,29.527,37ZM10.422,10.092V33.637H29.527V10.092ZM3.473,26.91H0V3.363A3.424,3.424,0,0,1,3.473,0H24.317V3.363H3.473V26.91Z',
        },
      },
    ],
  },

  desktop: {
    type: 'svg',
    attrs: {
      id: 'desktop',
      viewBox: '0 0 57.219 38.146',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'desktop-path-1',
          d: 'M47.683,39.378a4.762,4.762,0,0,0,4.744-4.768l.024-23.841A4.782,4.782,0,0,0,47.683,6H9.537a4.782,4.782,0,0,0-4.768,4.768V34.61a4.782,4.782,0,0,0,4.768,4.768H0v4.768H57.219V39.378ZM9.537,10.768H47.683V34.61H9.537Z',
          transform: 'translate(0 -6)',
        },
      },
    ],
  },
  desktop2: {
    type: 'svg',
    attrs: {
      id: 'desktop2',
      viewBox: '0 0 20 21',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'desktop2-g-1',
          clipPath: 'url(#desktop2-clip-1)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'desktop2-path-1',
              d: 'M19.2857 2.58911H0.714286C0.319196 2.58911 0 2.90831 0 3.3034V14.3748C0 14.7699 0.319196 15.0891 0.714286 15.0891H9.19643V17.5891H5.35714C5.16071 17.5891 5 17.7498 5 17.9463V19.0177C5 19.1159 5.08036 19.1963 5.17857 19.1963H14.8214C14.9196 19.1963 15 19.1159 15 19.0177V17.9463C15 17.7498 14.8393 17.5891 14.6429 17.5891H10.8036V15.0891H19.2857C19.6808 15.0891 20 14.7699 20 14.3748V3.3034C20 2.90831 19.6808 2.58911 19.2857 2.58911ZM18.3929 13.482H1.60714V4.19625H18.3929V13.482Z',
            },
          },
        ],
      },
      {
        type: 'def',
        attrs: {
          id: 'desktop2-def-1',
        },
        childs: [
          {
            type: 'clipPath',
            attrs: {
              id: 'desktop2-clipPath-1',
            },
            childs: [
              {
                type: 'rect',
                attrs: {
                  id: 'desktop2-clipPath-1',
                  width: 20,
                  height: 20,
                  transform: 'translate(0 0.890015)',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  tablet: {
    type: 'svg',
    attrs: {
      id: 'tablet',
      viewBox: '0 0 88.65 122.88',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'tablet-path-1',
          fillRule: 'evenodd',
          d: 'M88.65,3.62v115.63c0,1.99-1.63,3.62-3.62,3.62H3.62c-1.99,0-3.62-1.63-3.62-3.62V3.62C0,1.63,1.63,0,3.62,0 h81.4C87.02,0,88.65,1.63,88.65,3.62L88.65,3.62z M44.32,109.86c2.29,0,4.15,1.86,4.15,4.15c0,2.29-1.86,4.15-4.15,4.15 c-2.29,0-4.15-1.86-4.15-4.15C40.18,111.72,42.03,109.86,44.32,109.86L44.32,109.86z M83.74,6.46v98.75H5.42V6.46H83.74L83.74,6.46 z',
        },
      },
    ],
  },
  tablet2: {
    type: 'svg',
    attrs: {
      id: 'tablet2',
      viewBox: '0 0 20 21',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'tablet2-g-1',
          clipPath: 'url(#tablet2-clip-1)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'tablet2-path-1',
              d: 'M-6.24448e-07 4.46074L-6.24448e-08 17.3179C-2.80026e-08 18.1058 0.640625 18.7465 1.42857 18.7465L18.5714 18.7465C19.3594 18.7465 20 18.1058 20 17.3179L20 4.46074C20 3.6728 19.3594 3.03217 18.5714 3.03217L1.42857 3.03217C0.640624 3.03217 -6.58891e-07 3.6728 -6.24448e-07 4.46074ZM18.3929 4.63931L18.3929 17.1393L1.60714 17.1393L1.60714 4.63932L18.3929 4.63931ZM16.0714 11.7822C16.3082 11.7822 16.5353 11.6881 16.7028 11.5207C16.8702 11.3532 16.9643 11.1261 16.9643 10.8893C16.9643 10.6525 16.8702 10.4254 16.7028 10.258C16.5353 10.0905 16.3082 9.99646 16.0714 9.99646C15.8346 9.99646 15.6075 10.0905 15.4401 10.258C15.2726 10.4254 15.1786 10.6525 15.1786 10.8893C15.1786 11.1261 15.2726 11.3532 15.4401 11.5207C15.6075 11.6881 15.8346 11.7822 16.0714 11.7822Z',
            },
          },
        ],
      },
      {
        type: 'def',
        attrs: {
          id: 'tablet2-def-1',
        },
        childs: [
          {
            type: 'clipPath',
            attrs: {
              id: 'tablet2-clipPath-1',
            },
            childs: [
              {
                type: 'rect',
                attrs: {
                  id: 'tablet2-clipPath-1',
                  width: 20,
                  height: 20,
                  transform: 'translate(0 20.89) rotate(-90)',
                },
              },
            ],
          },
        ],
      },
    ],
  },

  'dots-horizontal': {
    type: 'svg',
    attrs: {
      id: 'dots-horizontal',
      viewBox: '0 0 32.499 7.437',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'dots-horizontal-g-1',
          transform: 'translate(39.999 -15) rotate(90)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'dots-horizontal-path-1',
              d: 'M20.937,18.719A2.219,2.219,0,1,1,18.719,16.5,2.219,2.219,0,0,1,20.937,18.719Z',
              transform: 'translate(0 5.031)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-horizontal-path-2',
              d: 'M18.719,15A3.719,3.719,0,1,1,15,18.719,3.723,3.723,0,0,1,18.719,15Zm0,4.437A.719.719,0,1,0,18,18.719.72.72,0,0,0,18.719,19.437Z',
              transform: 'translate(0 5.031)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-horizontal-path-3',
              d: 'M20.937,8.219A2.219,2.219,0,1,1,18.719,6a2.219,2.219,0,0,1,2.219,2.219Z',
              transform: 'translate(0 3)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-horizontal-path-4',
              d: 'M18.719,4.5A3.719,3.719,0,1,1,15,8.219,3.723,3.723,0,0,1,18.719,4.5Zm0,4.437A.719.719,0,1,0,18,8.219.72.72,0,0,0,18.719,8.937Z',
              transform: 'translate(0 3)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-horizontal-path-5',
              d: 'M20.937,29.219A2.219,2.219,0,1,1,18.719,27,2.219,2.219,0,0,1,20.937,29.219Z',
              transform: 'translate(0 7.062)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-horizontal-path-6',
              d: 'M18.719,25.5A3.719,3.719,0,1,1,15,29.219,3.723,3.723,0,0,1,18.719,25.5Zm0,4.437A.719.719,0,1,0,18,29.219.72.72,0,0,0,18.719,29.937Z',
              transform: 'translate(0 7.062)',
            },
          },
        ],
      },
    ],
  },

  'dots-vertical': {
    type: 'svg',
    attrs: {
      id: 'dots-vertical',
      viewBox: '0 0 7.437 32.499',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'dots-vertical-g-1',
          transform: 'translate(-15 -7.5)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'dots-vertical-path-1',
              d: 'M20.937,18.719A2.219,2.219,0,1,1,18.719,16.5,2.219,2.219,0,0,1,20.937,18.719Z',
              transform: 'translate(0 5.031)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-vertical-path-2',
              d: 'M18.719,15A3.719,3.719,0,1,1,15,18.719,3.723,3.723,0,0,1,18.719,15Zm0,4.437A.719.719,0,1,0,18,18.719.72.72,0,0,0,18.719,19.437Z',
              transform: 'translate(0 5.031)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-vertical-path-3',
              d: 'M20.937,8.219A2.219,2.219,0,1,1,18.719,6a2.219,2.219,0,0,1,2.219,2.219Z',
              transform: 'translate(0 3)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-vertical-path-4',
              d: 'M18.719,4.5A3.719,3.719,0,1,1,15,8.219,3.723,3.723,0,0,1,18.719,4.5Zm0,4.437A.719.719,0,1,0,18,8.219.72.72,0,0,0,18.719,8.937Z',
              transform: 'translate(0 3)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-vertical-path-5',
              d: 'M20.937,29.219A2.219,2.219,0,1,1,18.719,27,2.219,2.219,0,0,1,20.937,29.219Z',
              transform: 'translate(0 7.062)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'dots-vertical-path-6',
              d: 'M18.719,25.5A3.719,3.719,0,1,1,15,29.219,3.723,3.723,0,0,1,18.719,25.5Zm0,4.437A.719.719,0,1,0,18,29.219.72.72,0,0,0,18.719,29.937Z',
              transform: 'translate(0 7.062)',
            },
          },
        ],
      },
    ],
  },

  download: {
    type: 'svg',
    attrs: {
      id: 'download',
      viewBox: '0 0 34.381 34.381',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'download-g-1',
          transform: 'translate(1.5 1.5)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'download-path-1',
              d: 'M32.394,34.46H7.987A4.992,4.992,0,0,1,3,29.474V22.5a1.5,1.5,0,1,1,3,0v6.974A1.989,1.989,0,0,0,7.987,31.46H32.394a1.989,1.989,0,0,0,1.987-1.987V22.5a1.5,1.5,0,1,1,3,0v6.974A4.992,4.992,0,0,1,32.394,34.46Z',
              transform: 'translate(-4.5 -1.579)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'download-path-2',
              d: 'M19.217,25.217a1.5,1.5,0,0,1-1.061-.439L9.439,16.061a1.5,1.5,0,0,1,2.121-2.121L19.217,21.6l7.656-7.656a1.5,1.5,0,1,1,2.121,2.121l-8.717,8.717A1.5,1.5,0,0,1,19.217,25.217Z',
              transform: 'translate(-3.526 -2.796)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'download-path-3',
              d: 'M18,26.921a1.5,1.5,0,0,1-1.5-1.5V4.5a1.5,1.5,0,0,1,3,0V25.421A1.5,1.5,0,0,1,18,26.921Z',
              transform: 'translate(-2.31 -4.5)',
            },
          },
        ],
      },
    ],
  },

  edit: {
    type: 'svg',
    attrs: {
      id: 'edit',
      viewBox: '0 0 30 30',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'edit-path-1',
          d: 'M6.25,30l0,0h0L0,30V23.75L18.432,5.319l6.25,6.25ZM26.464,9.786h0L20.215,3.536,23.265.487a1.661,1.661,0,0,1,2.35,0l3.9,3.9a1.665,1.665,0,0,1,0,2.35l-3.05,3.048Z',
          transform: 'scale(0.8 0.8) translate(3 3)',
        },
      },
    ],
  },

  export: {
    type: 'svg',
    attrs: {
      id: 'export',
      viewBox: '0 0 32.711 32.711',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'export-path-1',
          d: 'M33.577,33.577H8.135V8.135H20.856V4.5H8.135A3.634,3.634,0,0,0,4.5,8.135V33.577a3.634,3.634,0,0,0,3.635,3.635H33.577a3.645,3.645,0,0,0,3.635-3.635V20.856H33.577ZM24.49,4.5V8.135h6.524L13.15,26l2.562,2.562L33.577,10.7v6.524h3.635V4.5Z',
          transform: 'translate(-4.5 -4.5)',
        },
      },
    ],
  },

  filter: {
    type: 'svg',
    attrs: {
      id: 'filter',
      viewBox: '0 0 40 26',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'filter-path-1',
          d: 'M24.444,26H15.556V21.667h8.888V26Zm8.89-10.833H6.666V10.834H33.334v4.333ZM40,4.333H0V0H40V4.333Z',
        },
      },
    ],
  },

  fix: {
    type: 'svg',
    attrs: {
      id: 'fix',
      viewBox: '0 0 37.186 37.186',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'fix-path-1',
          d: 'M18.828,3.21A11.066,11.066,0,0,0,6.2,1.111l7.369,7.346L8.47,13.535,1.1,6.189A11.006,11.006,0,0,0,14.923,21.271L30.39,36.691a1.7,1.7,0,0,0,2.394,0L36.69,32.8a1.682,1.682,0,0,0,0-2.387l-15.4-15.37A10.991,10.991,0,0,0,18.828,3.21Z',
        },
      },
    ],
  },

  favorite: {
    type: 'svg',
    attrs: {
      id: 'favorite',
      viewBox: '0 0 49 44.1',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'favorite-path-1',
          d: 'M24.5,44.1l-3.552-3.172C8.33,29.7,0,22.3,0,13.218A13.219,13.219,0,0,1,13.475,0,14.789,14.789,0,0,1,24.5,5.023,14.789,14.789,0,0,1,35.525,0,13.219,13.219,0,0,1,49,13.218C49,22.3,40.67,29.7,28.053,40.952Z',
        },
      },
    ],
  },

  help: {
    type: 'svg',
    attrs: {
      id: 'help',
      viewBox: '0 0 49.43 49.43',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'help-path-1',
          d: 'M28.09,3.375A24.715,24.715,0,1,0,52.805,28.09,24.727,24.727,0,0,0,28.09,3.375Zm2.5,39.568H25.595V37.952h4.991Zm-.024-7.486H25.619c0-7.961,7.415-7.391,7.415-12.334a4.965,4.965,0,0,0-4.943-4.955A5.015,5.015,0,0,0,23.147,23.1H18.2a9.886,9.886,0,0,1,19.772.012C37.976,29.29,30.562,29.991,30.562,35.457Z',
          transform: 'translate(-3.375 -3.375)',
        },
      },
    ],
  },

  info: {
    type: 'svg',
    attrs: {
      id: 'info',
      viewBox: '0 0 48.824 48.824',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'info-path-1',
          d: 'M27.787,3.375A24.412,24.412,0,1,0,52.2,27.787,24.408,24.408,0,0,0,27.787,3.375Zm2.23,35.679H25.533V22.142h4.483ZM27.775,20.3A2.343,2.343,0,1,1,30.2,17.952,2.352,2.352,0,0,1,27.775,20.3Z',
          transform: 'translate(-3.375 -3.375)',
        },
      },
    ],
  },

  inventory: {
    type: 'svg',
    attrs: {
      id: 'inventory',
      viewBox: '0 0 35.492 47.323',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'inventory-path-1',
          d: 'M35.492,11.271v.56H23.661V0h.56A2.219,2.219,0,0,1,25.79.65L34.842,9.7a2.219,2.219,0,0,1,.65,1.569Zm-12.57,3.518A2.225,2.225,0,0,1,20.7,12.57V0H2.218A2.218,2.218,0,0,0,0,2.218V45.1a2.218,2.218,0,0,0,2.218,2.218H33.274A2.218,2.218,0,0,0,35.492,45.1V14.788ZM11.388,37.018a.5.5,0,0,1-.705.023l-6-5.621a.5.5,0,0,1,0-.728l6-5.621a.5.5,0,0,1,.706.023l1.81,1.93a.5.5,0,0,1-.034.716L9.4,31.056l3.768,3.316a.5.5,0,0,1,.034.716Zm4.741,4.666-2.537-.737a.5.5,0,0,1-.34-.619l5.679-19.56a.5.5,0,0,1,.619-.34l2.537.737a.5.5,0,0,1,.34.619l-5.679,19.56a.5.5,0,0,1-.618.34ZM30.99,31.42l-6,5.621a.5.5,0,0,1-.705-.023l-1.81-1.93a.5.5,0,0,1,.034-.716l3.768-3.316L22.514,27.74a.5.5,0,0,1-.034-.716l1.81-1.93a.5.5,0,0,1,.705-.023l6,5.621a.5.5,0,0,1,0,.728Z',
        },
      },
    ],
  },

  link: {
    type: 'svg',
    attrs: {
      id: 'link',
      viewBox: '0 0 34 16',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'link-path-1',
          d: 'M25.5,16H18.7V12.96h6.8A5.127,5.127,0,0,0,30.77,8,5.128,5.128,0,0,0,25.5,3.04H18.7V0h6.8A8.271,8.271,0,0,1,34,8,8.27,8.27,0,0,1,25.5,16ZM15.3,16H8.5A8.271,8.271,0,0,1,0,8,8.271,8.271,0,0,1,8.5,0h6.8V3.04H8.5A5.129,5.129,0,0,0,3.23,8,5.128,5.128,0,0,0,8.5,12.96h6.8V16Zm8.5-6.4H10.2V6.4H23.8V9.6Z',
        },
      },
    ],
  },

  list: {
    type: 'svg',
    attrs: {
      id: 'list',
      viewBox: '0 0 47.192 41.293',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'list-path-1',
          d: 'M42.768,43.543H4.424A4.424,4.424,0,0,1,0,39.119V6.674A4.424,4.424,0,0,1,4.424,2.25H42.768a4.424,4.424,0,0,1,4.424,4.424V39.119A4.424,4.424,0,0,1,42.768,43.543ZM11.8,10.361a3.687,3.687,0,1,0,3.687,3.687A3.687,3.687,0,0,0,11.8,10.361Zm0,8.848A3.687,3.687,0,1,0,15.485,22.9,3.687,3.687,0,0,0,11.8,19.21Zm0,8.848a3.687,3.687,0,1,0,3.687,3.687A3.687,3.687,0,0,0,11.8,28.058ZM38.343,15.523V12.573a1.106,1.106,0,0,0-1.106-1.106H18.8A1.106,1.106,0,0,0,17.7,12.573v2.949A1.106,1.106,0,0,0,18.8,16.629H37.237A1.106,1.106,0,0,0,38.343,15.523Zm0,8.848V21.422a1.106,1.106,0,0,0-1.106-1.106H18.8A1.106,1.106,0,0,0,17.7,21.422v2.949A1.106,1.106,0,0,0,18.8,25.477H37.237A1.106,1.106,0,0,0,38.343,24.371Zm0,8.848V30.27a1.106,1.106,0,0,0-1.106-1.106H18.8A1.106,1.106,0,0,0,17.7,30.27V33.22A1.106,1.106,0,0,0,18.8,34.326H37.237A1.106,1.106,0,0,0,38.343,33.22Z',
          transform: 'translate(0 -2.25)',
        },
      },
    ],
  },

  logout: {
    type: 'svg',
    attrs: {
      id: 'logout',
      viewBox: '0 0 49.431 49.431',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'logout-g-1',
          transform: 'translate(-3.375 -3.375)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'logout-path-1',
              d: 'M13.5,25.2H36.041L30.86,30.511l3.553,3.553L45.82,22.657,34.413,11.25,30.729,14.8l5.311,5.311H13.5Z',
              transform: 'translate(6.986 5.433)',
            },
          },
          {
            type: 'g',
            attrs: {
              id: 'logout-g-2',
              transform: 'translate(3.375 3.375)',
            },
            childs: [
              {
                type: 'path',
                attrs: {
                  id: 'logout-path-2',
                  d: 'M28.055,47.732A19.653,19.653,0,0,1,14.188,14.2a19.593,19.593,0,0,1,27.71-.024l3.6-3.6a26.263,26.263,0,0,0-3.291-2.757,24.735,24.735,0,1,0,3.28,37.774L41.9,42A19.449,19.449,0,0,1,28.055,47.732Z',
                  transform: 'translate(-3.375 -3.375)',
                },
              },
              {
                type: 'path',
                attrs: {
                  id: 'logout-path-3',
                  d: 'M31.458,17.958H31.6V18.1h-.143Z',
                  transform: 'translate(16 6.686)',
                },
              },
            ],
          },
        ],
      },
    ],
  },

  message: {
    type: 'svg',
    attrs: {
      id: 'message',
      viewBox: '0 0 41 41',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'message-path-1',
          d: 'M22.432,2.5h.987q.055,0,.11,0A18.043,18.043,0,0,1,40.551,19.525q0,.055,0,.11v.945a18.09,18.09,0,0,1-18.08,18.082h-.042a17.951,17.951,0,0,1-7.278-1.551L5.132,40.451a2,2,0,0,1-2.53-2.53L5.943,27.9A18.088,18.088,0,0,1,22.432,2.5Zm.93,4h-.93a13.921,13.921,0,0,0-6.246,1.488l-.008,0a14.081,14.081,0,0,0-7.786,12.59A13.923,13.923,0,0,0,9.88,26.868,2,2,0,0,1,9.992,28.4l-2.33,6.989,6.989-2.33a2,2,0,0,1,1.534.112,13.921,13.921,0,0,0,6.246,1.488h.036a14.081,14.081,0,0,0,12.595-7.786l0-.008a13.919,13.919,0,0,0,1.488-6.282s0,0,0-.005v-.889A14.043,14.043,0,0,0,23.362,6.5Z',
          transorm: 'translate(-2 -2)',
        },
      },
    ],
  },

  minus: {
    type: 'svg',
    attrs: {
      id: 'minus',
      viewBox: '0 0 39 39',
    },
    childs: [
      {
        type: 'rect',
        attrs: {
          id: 'minus-path-1',
          width: '3',
          height: '29',
          rx: '1',
          transform: 'translate(34 18) rotate(90)',
        },
      },
    ],
  },

  'minus-square': {
    type: 'svg',
    attrs: {
      id: 'minus-square',
      viewBox: '0 0 38 38',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'minus-square-path-1',
          d: 'M33.778,38H4.222A4.227,4.227,0,0,1,0,33.778V4.222A4.227,4.227,0,0,1,4.222,0H33.778A4.227,4.227,0,0,1,38,4.222V33.778A4.227,4.227,0,0,1,33.778,38ZM8.444,16.889v4.222H29.556V16.889Z',
        },
      },
    ],
  },

  mobile: {
    type: 'svg',
    attrs: {
      id: 'mobile',
      viewBox: '0 0 33.845 54.151',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'mobile-path-1',
          d: 'M28.768,0H5.077A5.078,5.078,0,0,0,0,5.077v44a5.078,5.078,0,0,0,5.077,5.077H28.768a5.078,5.078,0,0,0,5.077-5.077v-44A5.078,5.078,0,0,0,28.768,0ZM16.922,50.767a3.384,3.384,0,1,1,3.384-3.384A3.381,3.381,0,0,1,16.922,50.767ZM28.768,39.344A1.273,1.273,0,0,1,27.5,40.614H6.346a1.273,1.273,0,0,1-1.269-1.269v-33A1.273,1.273,0,0,1,6.346,5.077H27.5a1.273,1.273,0,0,1,1.269,1.269Z',
        },
      },
    ],
  },

  notification: {
    type: 'svg',
    attrs: {
      id: 'notification',
      viewBox: '0 0 27.045 32.961',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'notification-path-1',
          d: 'M13.522,32.961a3.385,3.385,0,0,1-3.38-3.382H16.9A3.385,3.385,0,0,1,13.522,32.961Zm13.522-5.072H0V26.2l3.38-3.38V14.367A11.992,11.992,0,0,1,5.364,7.5a9.333,9.333,0,0,1,5.622-3.82V2.536a2.536,2.536,0,0,1,5.072,0V3.684a9.346,9.346,0,0,1,5.616,3.827,11.975,11.975,0,0,1,1.991,6.856v8.452l3.38,3.38v1.69Z',
        },
      },
    ],
  },

  pause: {
    type: 'svg',
    attrs: {
      id: 'pause',
      viewBox: '0 0 39 39',
    },
    childs: [
      {
        type: 'rect',
        attrs: {
          id: 'pause-rect-1',
          width: '39',
          height: '39',
          fill: 'none',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'pause-path-1',
          d: 'M10.75,19a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1H12a1,1,0,0,1,1,1V18a1,1,0,0,1-1,1ZM1,19a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H2.25a1,1,0,0,1,1,1V18a1,1,0,0,1-1,1Z',
          transform: 'translate(13 10)',
        },
      },
    ],
  },

  payment: {
    type: 'svg',
    attrs: {
      id: 'payment',
      viewBox: '0 0 46.973 35.23',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'payment-path-1',
          d: 'M45.14,5.784H6.974a4.417,4.417,0,0,0-4.4,4.4V36.61a4.417,4.417,0,0,0,4.4,4.4H45.14a4.417,4.417,0,0,0,4.4-4.4V10.188a4.417,4.417,0,0,0-4.4-4.4ZM6.974,8.72H45.14a1.488,1.488,0,0,1,1.468,1.468v4.4H5.507v-4.4A1.488,1.488,0,0,1,6.974,8.72ZM45.14,38.078H6.974A1.488,1.488,0,0,1,5.507,36.61V23.4h41.1V36.61a1.488,1.488,0,0,1-1.468,1.468Zm-36.7-8.807h2.936v5.872H8.442Zm5.872,0H17.25v5.872H14.314Zm5.872,0h2.936v5.872H20.186Z',
          transform: 'translate(-2.571 -5.784)',
        },
      },
    ],
  },

  'file-protect': {
    type: 'svg',
    attrs: {
      id: 'file-protect',
      viewBox: '0 0 19 19',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'file-protect-path-1',
          d: 'M12.3581 12.9317C12.3432 12.911 12.3236 12.8942 12.3009 12.8827C12.2782 12.8711 12.253 12.8652 12.2275 12.8654H11.3396C11.209 12.8654 11.1326 13.0141 11.209 13.1206L12.6916 15.1717C12.7559 15.2601 12.8864 15.2601 12.9507 15.1717L15.2449 11.9976C15.3213 11.8911 15.2449 11.7424 15.1143 11.7424H14.2244C14.1722 11.7424 14.1239 11.7666 14.0938 11.8087L12.8181 13.5726L12.3581 12.9317ZM13.228 5.63531V4.67102C13.228 4.58263 13.1556 4.51031 13.0672 4.51031H5.35296C5.26456 4.51031 5.19224 4.58263 5.19224 4.67102V5.63531C5.19224 5.7237 5.26456 5.79602 5.35296 5.79602H13.0672C13.1556 5.79602 13.228 5.7237 13.228 5.63531ZM5.35296 7.40316C5.26456 7.40316 5.19224 7.47549 5.19224 7.56388V8.52816C5.19224 8.61656 5.26456 8.68888 5.35296 8.68888H9.04939C9.13778 8.68888 9.2101 8.61656 9.2101 8.52816V7.56388C9.2101 7.47549 9.13778 7.40316 9.04939 7.40316H5.35296ZM9.04939 16.6041H3.5851V2.4612H14.8351V8.40763C14.8351 8.49602 14.9074 8.56834 14.9958 8.56834H16.1208C16.2092 8.56834 16.2815 8.49602 16.2815 8.40763V1.65763C16.2815 1.30205 15.9943 1.01477 15.6387 1.01477H2.78153C2.42595 1.01477 2.13867 1.30205 2.13867 1.65763V17.4076C2.13867 17.7632 2.42595 18.0505 2.78153 18.0505H9.04939C9.13778 18.0505 9.2101 17.9782 9.2101 17.8898V16.7648C9.2101 16.6764 9.13778 16.6041 9.04939 16.6041ZM17.1373 10.1594L13.2802 8.81946C13.2621 8.81343 13.246 8.81142 13.228 8.81142C13.2099 8.81142 13.1918 8.81343 13.1757 8.81946L9.31858 10.1594C9.28707 10.1701 9.25968 10.1904 9.24024 10.2174C9.22079 10.2444 9.21026 10.2768 9.2101 10.3101V15.3545C9.2101 15.4047 9.2322 15.4509 9.27238 15.4811L13.1295 18.4985C13.1576 18.5206 13.1938 18.5326 13.228 18.5326C13.2621 18.5326 13.2983 18.5206 13.3264 18.4985L17.1835 15.4811C17.2217 15.4509 17.2458 15.4047 17.2458 15.3545V10.3101C17.2458 10.2418 17.2016 10.1815 17.1373 10.1594ZM16.0003 14.8302L13.228 16.9978L10.4556 14.8302V11.0795L13.228 10.1152L16.0003 11.0795V14.8302Z',
          transform: 'translate(0.692871 0.777344)',
        },
      },
    ],
  },

  cookie: {
    type: 'svg',
    attrs: {
      id: 'file-protect',
      viewBox: '0 0 18 18',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'cookie-path-1',
          d: 'M9.19287 17.2773C4.50499 17.2773 0.692871 13.4652 0.692871 8.77734C0.692871 4.08946 4.50499 0.277344 9.19287 0.277344C13.8807 0.277344 17.6929 4.08946 17.6929 8.77734C17.6929 13.4652 13.8807 17.2773 9.19287 17.2773ZM9.19287 0.792495C4.78833 0.792495 1.20802 4.3728 1.20802 8.77734C1.20802 13.1819 4.78833 16.7622 9.19287 16.7622C13.5974 16.7622 17.1777 13.1819 17.1777 8.77734C17.1777 4.3728 13.5974 0.792495 9.19287 0.792495ZM9.19287 16.247C5.07166 16.247 1.72317 12.8986 1.72317 8.77734C1.72317 4.65613 5.07166 1.30765 9.19287 1.30765C13.3141 1.30765 16.6626 4.65613 16.6626 8.77734C16.6626 12.8986 13.3141 16.247 9.19287 16.247ZM9.19287 1.8228C5.36014 1.8228 2.23833 4.94462 2.23833 8.77734C2.23833 12.6101 5.36014 15.7319 9.19287 15.7319C13.0256 15.7319 16.1474 12.6101 16.1474 8.77734C16.1474 4.94462 13.0256 1.8228 9.19287 1.8228ZM9.19287 13.6713C8.74469 13.6713 8.42014 13.3467 8.42014 12.8986C8.42014 12.4504 8.73954 12.1258 9.19287 12.1258C9.6462 12.1258 9.9656 12.4452 9.9656 12.8986C9.9656 13.3519 9.64105 13.6713 9.19287 13.6713ZM9.19287 12.641C9.02802 12.641 8.9353 12.7337 8.9353 12.8986C8.9353 13.0634 9.02802 13.1561 9.19287 13.1561C9.35772 13.1561 9.45045 13.0634 9.45045 12.8986C9.45045 12.7337 9.35772 12.641 9.19287 12.641ZM11.7686 12.1258C11.3204 12.1258 10.9959 11.8013 10.9959 11.3531C10.9959 10.9049 11.3204 10.5804 11.7686 10.5804C12.2168 10.5804 12.5414 10.9049 12.5414 11.3531C12.5414 11.8013 12.2168 12.1258 11.7686 12.1258ZM11.7686 11.0955C11.6038 11.0955 11.5111 11.1883 11.5111 11.3531C11.5111 11.5179 11.6038 11.6107 11.7686 11.6107C11.9335 11.6107 12.0262 11.5179 12.0262 11.3531C12.0262 11.1883 11.9335 11.0955 11.7686 11.0955ZM6.61711 12.1258C6.16893 12.1258 5.84439 11.8013 5.84439 11.3531C5.84439 10.9049 6.16378 10.5804 6.61711 10.5804C7.07045 10.5804 7.38984 10.8998 7.38984 11.3531C7.38984 11.8064 7.0653 12.1258 6.61711 12.1258ZM6.61711 11.0955C6.45226 11.0955 6.35954 11.1883 6.35954 11.3531C6.35954 11.5179 6.45226 11.6107 6.61711 11.6107C6.78196 11.6107 6.87469 11.5179 6.87469 11.3531C6.87469 11.1883 6.78196 11.0955 6.61711 11.0955ZM13.3141 9.55007C12.8659 9.55007 12.5414 9.22552 12.5414 8.77734C12.5414 8.32916 12.8659 8.00462 13.3141 8.00462C13.7623 8.00462 14.0868 8.32916 14.0868 8.77734C14.0868 9.22552 13.7623 9.55007 13.3141 9.55007ZM13.3141 8.51977C13.1492 8.51977 13.0565 8.6125 13.0565 8.77734C13.0565 8.94219 13.1492 9.03492 13.3141 9.03492C13.4789 9.03492 13.5717 8.94219 13.5717 8.77734C13.5717 8.6125 13.4789 8.51977 13.3141 8.51977ZM9.19287 9.55007C8.74469 9.55007 8.42014 9.22552 8.42014 8.77734C8.42014 8.32916 8.73954 8.00462 9.19287 8.00462C9.6462 8.00462 9.9656 8.32401 9.9656 8.77734C9.9656 9.23068 9.64105 9.55007 9.19287 9.55007ZM9.19287 8.51977C9.02802 8.51977 8.9353 8.6125 8.9353 8.77734C8.9353 8.94219 9.02802 9.03492 9.19287 9.03492C9.35772 9.03492 9.45045 8.94219 9.45045 8.77734C9.45045 8.6125 9.35772 8.51977 9.19287 8.51977ZM5.07166 9.55007C4.62348 9.55007 4.29893 9.22552 4.29893 8.77734C4.29893 8.32916 4.61833 8.00462 5.07166 8.00462C5.52499 8.00462 5.84439 8.32401 5.84439 8.77734C5.84439 9.23068 5.51984 9.55007 5.07166 9.55007ZM5.07166 8.51977C4.90681 8.51977 4.81408 8.6125 4.81408 8.77734C4.81408 8.94219 4.90681 9.03492 5.07166 9.03492C5.23651 9.03492 5.32923 8.94219 5.32923 8.77734C5.32923 8.6125 5.23651 8.51977 5.07166 8.51977ZM11.7686 6.97431C11.3204 6.97431 10.9959 6.64977 10.9959 6.20159C10.9959 5.7534 11.3204 5.42886 11.7686 5.42886C12.2168 5.42886 12.5414 5.7534 12.5414 6.20159C12.5414 6.64977 12.2168 6.97431 11.7686 6.97431ZM11.7686 5.94401C11.6038 5.94401 11.5111 6.03674 11.5111 6.20159C11.5111 6.36643 11.6038 6.45916 11.7686 6.45916C11.9335 6.45916 12.0262 6.36643 12.0262 6.20159C12.0262 6.03674 11.9335 5.94401 11.7686 5.94401ZM6.61711 6.97431C6.16893 6.97431 5.84439 6.64977 5.84439 6.20159C5.84439 5.7534 6.16378 5.42886 6.61711 5.42886C7.07045 5.42886 7.38984 5.74825 7.38984 6.20159C7.38984 6.65492 7.0653 6.97431 6.61711 6.97431ZM6.61711 5.94401C6.45226 5.94401 6.35954 6.03674 6.35954 6.20159C6.35954 6.36643 6.45226 6.45916 6.61711 6.45916C6.78196 6.45916 6.87469 6.36643 6.87469 6.20159C6.87469 6.03674 6.78196 5.94401 6.61711 5.94401ZM9.19287 5.42886C8.74469 5.42886 8.42014 5.10431 8.42014 4.65613C8.42014 4.20795 8.73954 3.8834 9.19287 3.8834C9.6462 3.8834 9.9656 4.2028 9.9656 4.65613C9.9656 5.10946 9.64105 5.42886 9.19287 5.42886ZM9.19287 4.39856C9.02802 4.39856 8.9353 4.49128 8.9353 4.65613C8.9353 4.82098 9.02802 4.91371 9.19287 4.91371C9.35772 4.91371 9.45045 4.82098 9.45045 4.65613C9.45045 4.49128 9.35772 4.39856 9.19287 4.39856Z',
        },
      },
    ],
  },

  play: {
    type: 'svg',
    attrs: {
      id: 'play',
      viewBox: '0 0 39 39',
    },
    childs: [
      {
        type: 'rect',
        attrs: {
          id: 'play-rect-1',
          width: '39',
          height: '39',
          fill: 'none',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'play-path-1',
          d: 'M8.616,1.676a1,1,0,0,1,1.769,0l7.841,14.858A1,1,0,0,1,17.341,18H1.659a1,1,0,0,1-.884-1.467Z',
          transform: 'translate(29 10) rotate(90)',
        },
      },
    ],
  },

  plus2: {
    type: 'svg',
    attrs: {
      id: 'plus2',
      viewBox: '0 0 39 39',
    },
    childs: [
      {
        type: 'rect',
        attrs: {
          id: 'plus2-rect-1',
          width: '39',
          height: '39',
          fill: 'none',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'plus2-path-1',
          d: 'M13.889,29a1,1,0,0,1-1-1V16.111H1a1,1,0,0,1-1-1V13.889a1,1,0,0,1,1-1H12.889V1a1,1,0,0,1,1-1h1.222a1,1,0,0,1,1,1V12.889H28a1,1,0,0,1,1,1v1.222a1,1,0,0,1-1,1H16.111V28a1,1,0,0,1-1,1Z',
          transform: 'translate(5 5)',
        },
      },
    ],
  },

  profile: {
    type: 'svg',
    attrs: {
      id: 'profile',
      viewBox: '0 0 40.563 47.323',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'profile-path-1',
          d: 'M40.556,3H9.007A4.506,4.506,0,0,0,4.5,7.507V39.056a4.506,4.506,0,0,0,4.507,4.507h9.014l6.76,6.76,6.76-6.76h9.014a4.52,4.52,0,0,0,4.507-4.507V7.507A4.52,4.52,0,0,0,40.556,3ZM24.781,10.436A6.084,6.084,0,1,1,18.7,16.521a6.088,6.088,0,0,1,6.084-6.084ZM38.3,34.549H11.26V32.52c0-4.507,9.014-6.986,13.521-6.986S38.3,28.014,38.3,32.52Z',
          transform: 'translate(-4.5 -3)',
        },
      },
    ],
  },

  publisher: {
    type: 'svg',
    attrs: {
      id: 'publisher',
      viewBox: '0 0 41.305 44.367',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'publisher-g-1',
          transform: 'translate(-4.8 -0.8)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'publisher-path-1',
              d: 'M51.872,67.645A12.972,12.972,0,1,1,64.845,54.672,12.976,12.976,0,0,1,51.872,67.645Zm0-24.368a11.4,11.4,0,1,0,11.4,11.351A11.409,11.409,0,0,0,51.872,43.277Z',
              transform: 'translate(-18.74 -22.477)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'publisher-path-2',
              d: 'M21.736,45.167H5.656a.855.855,0,0,1-.856-.856V1.656A.855.855,0,0,1,5.656.8H32.682a.856.856,0,0,1,.586.225L41.06,8.683a.818.818,0,0,1,.27.631v7.792a.856.856,0,1,1-1.712,0V9.673l-7.3-7.162H6.512v40.9H21.736a.855.855,0,0,1,.856.856A.866.866,0,0,1,21.736,45.167Z',
              transform: 'translate(0 0)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'publisher-path-3',
              d: 'M18.591,30.882H36.653a.991.991,0,0,0,0-1.982H18.591a1,1,0,0,0-.991.991A.971.971,0,0,0,18.591,30.882Z',
              transform: 'translate(-7.034 -15.443)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'publisher-path-4',
              d: 'M18.791,18.782H36.853a.991.991,0,0,0,0-1.982H18.791a.991.991,0,0,0,0,1.982Z',
              transform: 'translate(-7.144 -8.793)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'publisher-path-5',
              d: 'M18.791,43.282h10.54a.991.991,0,0,0,0-1.982H18.791a.991.991,0,1,0,0,1.982Z',
              transform: 'translate(-7.144 -22.258)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'publisher-path-6',
              d: 'M25.267,56.082H18.691a.991.991,0,1,1,0-1.982h6.576a.991.991,0,0,1,0,1.982Z',
              transform: 'translate(-7.089 -29.292)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'publisher-path-7',
              d: 'M66.092,75.675h0c0-.045-.405-4.775-6.4-4.775-6.081,0-6.4,4.775-6.4,4.82v1.4a.711.711,0,0,0,.721.721H65.372a.711.711,0,0,0,.721-.721Z',
              transform: 'translate(-26.654 -38.525)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'publisher-path-8',
              d: 'M63.853,59.727A3.534,3.534,0,1,0,60.7,56.213,3.34,3.34,0,0,0,63.853,59.727Z',
              transform: 'translate(-30.721 -28.523)',
            },
          },
        ],
      },
    ],
  },

  refresh: {
    type: 'svg',
    attrs: {
      id: 'refresh',
      viewBox: '0 0 45 32',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'refresh-path-1',
          d: 'M22.5,32a16.519,16.519,0,0,1-8.713-2.48l2.986-2.92a12.3,12.3,0,0,0,18-10.6H28.638l8.181-8L45,16H38.864A16.2,16.2,0,0,1,22.5,32ZM8.181,24h0L0,16H6.136A16.2,16.2,0,0,1,22.5,0a16.522,16.522,0,0,1,8.715,2.48L28.227,5.4a12.3,12.3,0,0,0-18,10.6h6.136L8.183,24Z',
        },
      },
    ],
  },

  reminder: {
    type: 'svg',
    attrs: {
      id: 'reminder',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'reminder-path-1',
          d: 'M87,120.26h37.75a2.41,2.41,0,0,0,1.85-3.88l-7-9a2.37,2.37,0,0,0-3.69,0l-6.58,7.9-9.94-12.77a2.32,2.32,0,0,0-3.73,0l-10.51,14A2.37,2.37,0,0,0,87,120.26Z',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'reminder-path-2',
          d: ' M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0ZM44.42,129.67c-4.73,0-9.47-4.73-9.47-9.46h9.47Zm0-18.92H35v-9.47h9.47Zm0-18.93H35V82.36h9.47Zm0-18.92H35V63.44h9.47Zm0-18.93H35c0-4.73,4.74-9.46,9.47-9.46Zm66.23-9.46h9.46V54h-9.46Zm-18.92,0h9.46V54H91.73Zm-18.93,0h9.47V54H72.8Zm-9.46,85.16H53.88v-9.46h9.46Zm0-75.7H53.88V44.51h9.46ZM139,120.21a9.49,9.49,0,0,1-9.46,9.46H72.8V91.82a9.49,9.49,0,0,1,9.47-9.46H139Zm0-47.31h-9.46V63.44H139ZM129.58,54V44.51c4.73,0,9.46,4.73,9.46,9.46Z',
        },
      },
    ],
  },

  save: {
    type: 'svg',
    attrs: {
      id: 'save',
      viewBox: '0 0 38 38',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'save-g-1',
          transform: 'translate(2 2)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'save-path-1',
              d: 'M34.77,40.554H8.284A5.79,5.79,0,0,1,2.5,34.77V8.284A5.79,5.79,0,0,1,8.284,2.5H29.095a2,2,0,0,1,1.414.586l9.459,9.459a2,2,0,0,1,.586,1.414V34.77A5.79,5.79,0,0,1,34.77,40.554ZM8.284,6.5A1.786,1.786,0,0,0,6.5,8.284V34.77a1.786,1.786,0,0,0,1.784,1.784H34.77a1.786,1.786,0,0,0,1.784-1.784V14.788L28.266,6.5Z',
              transform: 'translate(-4.5 -4.5)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'save-path-2',
              d: 'M29.419,36.635a2,2,0,0,1-2-2V21.5H12.5V34.635a2,2,0,0,1-4,0V19.5a2,2,0,0,1,2-2H29.419a2,2,0,0,1,2,2V34.635A2,2,0,0,1,29.419,36.635Z',
              transform: 'translate(-2.932 -0.581)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'save-path-3',
              d: 'M25.635,15.959H10.5a2,2,0,0,1-2-2V4.5a2,2,0,0,1,4,0v7.459H25.635a2,2,0,0,1,0,4Z',
              transform: 'translate(-2.932 -4.5)',
            },
          },
        ],
      },
    ],
  },

  'scroll-down': {
    type: 'svg',
    attrs: {
      id: 'scroll-down',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'scroll-down-path-1',
          d: 'M87,34.9h0c-20.13,0-36.45,18.56-36.45,38.68v27c0,20.13,16.32,38.58,36.45,38.58h0c20.12,0,36.44-18.45,36.44-38.58v-27C123.44,53.46,107.12,34.9,87,34.9ZM81,52.44a4.58,4.58,0,0,1,4.58-4.58h2.76A4.58,4.58,0,0,1,93,52.44v8.85a4.58,4.58,0,0,1-4.58,4.58H85.62A4.58,4.58,0,0,1,81,61.29Zm19.54,58.85L88.31,123.56a1.85,1.85,0,0,1-2.63,0L73.41,111.29a1.85,1.85,0,0,1,0-2.63,1.88,1.88,0,0,1,2.64,0l9.09,9.09V97a1.87,1.87,0,0,1,3.73,0v20.8L98,108.66a1.86,1.86,0,1,1,2.62,2.63Z',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'scroll-down-path-2',
          d: ' M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0Zm5.86,103A42.87,42.87,0,0,1,87,145.85h0A42.87,42.87,0,0,1,44.13,103V71.2A42.87,42.87,0,0,1,87,28.33h0A42.87,42.87,0,0,1,129.86,71.2Z',
        },
      },
    ],
  },

  'scroll-up': {
    type: 'svg',
    attrs: {
      id: 'scroll-up',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'scroll-up-path-1',
          d: 'M87,34.9h0c-20.13,0-36.45,18.56-36.45,38.68v27c0,20.13,16.32,38.58,36.45,38.58h0c20.12,0,36.44-18.45,36.44-38.58v-27C123.44,53.46,107.12,34.9,87,34.9ZM81,52.44a4.58,4.58,0,0,1,4.58-4.58h2.76A4.58,4.58,0,0,1,93,52.44v8.85a4.58,4.58,0,0,1-4.58,4.58H85.62A4.58,4.58,0,0,1,81,61.29Zm19.54,58.09a1.86,1.86,0,0,1-2.64,0l-9.09-9.09v20.81a1.87,1.87,0,0,1-3.73,0V101.44L76,110.53a1.86,1.86,0,1,1-2.63-2.63L85.68,95.63a1.85,1.85,0,0,1,2.63,0l12.27,12.27A1.85,1.85,0,0,1,100.58,110.53Z',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'scroll-up-path-2',
          d: ' M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0Zm5.86,103A42.87,42.87,0,0,1,87,145.85h0A42.87,42.87,0,0,1,44.13,103V71.2A42.87,42.87,0,0,1,87,28.33h0A42.87,42.87,0,0,1,129.86,71.2Z',
        },
      },
    ],
  },

  search: {
    type: 'svg',
    attrs: {
      id: 'search',
      viewBox: '0 0 48 48',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'search-g-1',
          transform: 'translate(-206 -1168)',
        },
        childs: [
          {
            type: 'rect',
            attrs: {
              id: 'search-rect-1',
              width: '48',
              height: '48',
              fill: 'none',
              transform: 'translate(206 1168)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'search-path-1',
              d: 'M227.2,1172a17.158,17.158,0,1,1-6.7,1.352A17.081,17.081,0,0,1,227.2,1172Zm0,30.4a13.2,13.2,0,1,0-9.337-3.865A13.108,13.108,0,0,0,227.2,1202.4Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'search-path-2',
              d: 'M12.054,14.054a1.994,1.994,0,0,1-1.414-.586L-1.414,1.414a2,2,0,0,1,0-2.828,2,2,0,0,1,2.828,0L13.468,10.639a2,2,0,0,1-1.414,3.414Z',
              transform: 'translate(237.947 1199.947)',
            },
          },
        ],
      },
    ],
  },

  settings: {
    type: 'svg',
    attrs: {
      id: 'settings',
      viewBox: '0 0 36.354 38.374',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'settings-path-1',
          d: 'M21.915,38.374H14.438a.957.957,0,0,1-.936-.815l-.7-5.085A13.557,13.557,0,0,1,9.646,30.6L5,32.522a1,1,0,0,1-.324.054.918.918,0,0,1-.821-.486L.111,25.447a1.009,1.009,0,0,1,.235-1.223l3.949-3.166a12.466,12.466,0,0,1-.14-1.871,12.239,12.239,0,0,1,.163-1.871L.369,14.151a.944.944,0,0,1-.233-1.223L3.874,6.283a.928.928,0,0,1,.812-.5.9.9,0,0,1,.333.064L9.671,7.771A14,14,0,0,1,12.826,5.9l.7-5.085A.918.918,0,0,1,14.438,0h7.477a.943.943,0,0,1,.936.815l.7,5.085a13.623,13.623,0,0,1,3.155,1.871l4.65-1.919a1,1,0,0,1,.324-.054.918.918,0,0,1,.821.486l3.74,6.645a1.008,1.008,0,0,1-.235,1.223l-3.949,3.166a12.257,12.257,0,0,1,.14,1.871,16.054,16.054,0,0,1-.117,1.871l3.9,3.166a.944.944,0,0,1,.233,1.223L32.479,32.09a.928.928,0,0,1-.812.5.9.9,0,0,1-.333-.064L26.683,30.6a13.873,13.873,0,0,1-3.155,1.871l-.7,5.085A.894.894,0,0,1,21.915,38.374ZM18.177,11.993a7.2,7.2,0,0,0,0,14.39,7.2,7.2,0,0,0,0-14.39Z',
        },
      },
    ],
  },

  share: {
    type: 'svg',
    attrs: {
      id: 'share',
      viewBox: '0 0 30.425 33.806',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'share-path-1',
          d: 'M25.354,23.895A4.911,4.911,0,0,0,22.041,25.2L9.99,18.159a5.577,5.577,0,0,0,.152-1.188,5.577,5.577,0,0,0-.152-1.188L21.906,8.808a5.054,5.054,0,0,0,8.519-3.717,5.071,5.071,0,1,0-10.142,0,5.576,5.576,0,0,0,.152,1.188L8.519,13.254a5.091,5.091,0,1,0,0,7.433l12.035,7.06a4.806,4.806,0,0,0-.135,1.1,4.936,4.936,0,1,0,4.936-4.955Z',
        },
      },
    ],
  },

  'squares-menu': {
    type: 'svg',
    attrs: {
      id: 'squares-menu',
      viewBox: '0 0 35 35',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'squares-menu-path-1',
          d: 'M35,35H26.249V26.249H35V35ZM21.875,35H13.125V26.249h8.749V35ZM8.749,35H0V26.249H8.749V35ZM35,21.875H26.249V13.125H35v8.749Zm-13.125,0H13.125V13.125h8.749v8.749Zm-13.125,0H0V13.125H8.749v8.749ZM35,8.749H26.249V0H35V8.749Zm-13.125,0H13.125V0h8.749V8.749Zm-13.125,0H0V0H8.749V8.749Z',
        },
      },
    ],
  },

  'small-screen': {
    type: 'svg',
    attrs: {
      id: 'small-screen',
      viewBox: '0 0 23 23',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'small-screen-path-1',
          d: 'M18.071,23H14.785V14.785H23v3.285H18.071V23ZM8.215,23H4.928V18.071H0V14.785H8.215V23ZM23,8.215H14.785V0h3.285V4.928H23V8.215Zm-14.785,0H0V4.928H4.928V0H8.215V8.215Z',
        },
      },
    ],
  },

  start: {
    type: 'svg',
    attrs: {
      id: 'start',
      viewBox: '0 0 38 37',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'start-path-1',
          d: 'M7.253,37v0l3.12-13.687L0,14.1l13.661-1.186L19,0l5.339,12.892L38,14.1,27.646,23.309l3.1,13.684L19,29.735,7.257,37ZM19,26.093h0l7.162,4.439-1.9-8.333,6.308-5.608-8.323-.741L19,7.985l-3.23,7.846-8.321.741,6.307,5.608-1.9,8.333L19,26.094Z',
        },
      },
    ],
  },

  'start-full': {
    type: 'svg',
    attrs: {
      id: 'start-full',
      viewBox: '0 0 38.397 36.477',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'start-full-path-1',
          d: 'M19.2,29.316l11.865,7.161-3.149-13.5L38.4,13.9l-13.8-1.171L19.2,0,13.8,12.729,0,13.9l10.482,9.081-3.149,13.5Z',
        },
      },
    ],
  },

  'star-half': {
    type: 'svg',
    attrs: {
      id: 'star-half',
      viewBox: '0 0 38 37',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'star-half-path-1',
          d: 'M7.253,37v0l3.12-13.687L0,14.1l13.661-1.186L19,0l5.339,12.892L38,14.1,27.646,23.309l3.1,13.684L19,29.735,7.257,37ZM19,7.986h0l0,18.107,7.163,4.439-1.9-8.333,6.308-5.608-8.323-.741Z',
        },
      },
    ],
  },

  stats: {
    type: 'svg',
    attrs: {
      id: 'stats',
      viewBox: '0 0 37.14 40.516',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'stats-g-1',
          transform: 'translate(-5.625 -4.5)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'stats-path-1',
              d: 'M13.219,45.016h5.064a.847.847,0,0,0,.844-.844V5.344a.847.847,0,0,0-.844-.844H13.219a.847.847,0,0,0-.844.844V44.172A.847.847,0,0,0,13.219,45.016Z',
              transform: 'translate(3.379)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'stats-path-2',
              d: 'M6.469,37.132h5.064a.847.847,0,0,0,.844-.844V21.094a.847.847,0,0,0-.844-.844H6.469a.847.847,0,0,0-.844.844V36.288A.847.847,0,0,0,6.469,37.132Z',
              transform: 'translate(0 7.884)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'stats-path-3',
              d: 'M19.98,39.384h5.043a.851.851,0,0,0,.855-.855V16.6a.851.851,0,0,0-.855-.855H19.98a.851.851,0,0,0-.855.855V38.53A.851.851,0,0,0,19.98,39.384Z',
              transform: 'translate(6.758 5.632)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'stats-path-4',
              d: 'M25.875,9.855V41.909a.851.851,0,0,0,.855.855h5.043a.851.851,0,0,0,.855-.855V9.855A.851.851,0,0,0,31.773,9H26.73A.851.851,0,0,0,25.875,9.855Z',
              transform: 'translate(10.137 2.253)',
            },
          },
        ],
      },
    ],
  },

  'swipe-down': {
    type: 'svg',
    attrs: {
      id: 'swipe-down',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'swipe-down-path-1',
          d: 'M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0ZM88,35.71A21.8,21.8,0,0,1,100.1,75.63V57.51a12.11,12.11,0,0,0-24.22,0V75.63A21.8,21.8,0,0,1,88,35.71ZM54.69,98.85H38.92a2.82,2.82,0,0,1-2-4.82l5.33-5.33a29.59,29.59,0,0,1,9.37-46.13,3.53,3.53,0,0,1,4.85,2.11,3.47,3.47,0,0,1-1.8,4.24A22.46,22.46,0,0,0,47.3,83.65l5.38-5.39a2.83,2.83,0,0,1,4.83,2V96A2.83,2.83,0,0,1,54.69,98.85Zm72.88,8.61-3,21.65a9.66,9.66,0,0,1-9.59,8.33H85.38a9.84,9.84,0,0,1-6.88-2.81L59.07,115.21a5.45,5.45,0,0,1,5-9.16l16.67,3.49v-52a7.27,7.27,0,1,1,14.53,0V86.58h2.95a9.68,9.68,0,0,1,4.32,1l19.76,9.84A9.7,9.7,0,0,1,127.57,107.46Z',
        },
      },
    ],
  },

  'swipe-left': {
    type: 'svg',
    attrs: {
      id: 'swipe-left',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'swipe-left-path-1',
          d: 'M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0ZM38.24,87.28A21.8,21.8,0,1,1,75,76.12L62.22,63.3A12.11,12.11,0,0,0,45.09,80.43L57.9,93.24A21.71,21.71,0,0,1,38.24,87.28Zm91,22.06-20.9,20.9a9.92,9.92,0,0,1-6.85,2.88H74a5.45,5.45,0,0,1-3-10L85.3,113.8,48.51,77A7.27,7.27,0,0,1,58.79,66.73L79.34,87.28l2.09-2.09a9.58,9.58,0,0,1,3.77-2.33l20.93-7A9.72,9.72,0,0,1,117,79.2l13.15,17.47A9.66,9.66,0,0,1,129.22,109.34ZM139.7,62.62a3.46,3.46,0,0,1-4.23-1.8,22.47,22.47,0,0,0-34.73-7.4l5.39,5.39a2.83,2.83,0,0,1-2,4.83H88.36a2.82,2.82,0,0,1-2.82-2.82V45a2.82,2.82,0,0,1,4.82-2l5.33,5.33a29.59,29.59,0,0,1,46.13,9.37A3.54,3.54,0,0,1,139.7,62.62Z',
        },
      },
    ],
  },

  'swipe-right': {
    type: 'svg',
    attrs: {
      id: 'swipe-right',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'swipe-right-path-1',
          d: 'M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0ZM39.33,60a3.54,3.54,0,0,1-2.11-4.86,29.57,29.57,0,0,1,46.12-9.36l5.34-5.34a2.82,2.82,0,0,1,4.82,2V58.22A2.83,2.83,0,0,1,90.68,61H74.91a2.83,2.83,0,0,1-2-4.82l5.38-5.39a22.46,22.46,0,0,0-34.73,7.39A3.47,3.47,0,0,1,39.33,60ZM105,130.52H77.57a9.87,9.87,0,0,1-6.86-2.88L49.82,106.75a9.67,9.67,0,0,1-.89-12.68L62.08,76.6a9.7,9.7,0,0,1,10.83-3.35l20.93,7A9.54,9.54,0,0,1,97.6,82.6l2.09,2.09,20.56-20.56a7.27,7.27,0,0,1,10.27,10.28L93.73,111.2,108,120.52a5.44,5.44,0,0,1-2.94,10ZM140.8,84.69a21.73,21.73,0,0,1-19.66,6L134,77.84a12.11,12.11,0,0,0-17.13-17.13L104,73.52A21.8,21.8,0,1,1,140.8,84.69Z',
        },
      },
    ],
  },

  'swipe-up': {
    type: 'svg',
    attrs: {
      id: 'swipe-up',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'swipe-up-path-1',
          d: 'M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0ZM88,35.71A21.8,21.8,0,0,1,100.1,75.63V57.51a12.11,12.11,0,0,0-24.22,0V75.63A21.8,21.8,0,0,1,88,35.71ZM54.69,92.17a3.47,3.47,0,0,1,1.8,4.24,3.54,3.54,0,0,1-4.85,2.11,29.59,29.59,0,0,1-9.37-46.13l-5.33-5.33a2.82,2.82,0,0,1,2-4.82H54.69a2.82,2.82,0,0,1,2.82,2.82V60.83a2.83,2.83,0,0,1-4.83,2L47.3,57.44a22.46,22.46,0,0,0,7.39,34.73Zm72.88,15.29-3,21.65a9.66,9.66,0,0,1-9.59,8.33H85.38a9.84,9.84,0,0,1-6.88-2.81L59.07,115.21a5.45,5.45,0,0,1,5-9.16l16.67,3.49v-52a7.27,7.27,0,1,1,14.53,0V86.58h2.95a9.68,9.68,0,0,1,4.32,1l19.76,9.84A9.7,9.7,0,0,1,127.57,107.46Z',
        },
      },
    ],
  },

  touch: {
    type: 'svg',
    attrs: {
      id: 'touch',
      viewBox: '0 0 174 174',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'touch-path-1',
          d: 'M124,0H50A50,50,0,0,0,0,50v74a50,50,0,0,0,50,50h74a50,50,0,0,0,50-50V50A50,50,0,0,0,124,0ZM83.53,35.71A21.8,21.8,0,0,1,95.64,75.63V57.51a12.11,12.11,0,0,0-24.22,0V75.63A21.8,21.8,0,0,1,83.53,35.71Zm39.58,71.75-3,21.65a9.66,9.66,0,0,1-9.6,8.33H80.91A9.88,9.88,0,0,1,74,134.63L54.61,115.21a5.45,5.45,0,0,1,5-9.16l16.66,3.49v-52a7.27,7.27,0,1,1,14.54,0V86.58h3a9.64,9.64,0,0,1,4.31,1l19.77,9.84A9.7,9.7,0,0,1,123.11,107.46Z',
        },
      },
    ],
  },

  trash: {
    type: 'svg',
    attrs: {
      id: 'trash',
      viewBox: '0 0 32.5 37',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'trash-g-1',
          transform: 'translate(-539.5 -1870.054)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'trash-path-1',
              d: 'M30.375,2.25H21.938L21.277.935A1.688,1.688,0,0,0,19.765,0H11.728a1.668,1.668,0,0,0-1.5.935L9.563,2.25H1.125A1.125,1.125,0,0,0,0,3.375v2.25A1.125,1.125,0,0,0,1.125,6.75h29.25A1.125,1.125,0,0,0,31.5,5.625V3.375A1.125,1.125,0,0,0,30.375,2.25ZM3.741,32.836A3.375,3.375,0,0,0,7.109,36H24.391a3.375,3.375,0,0,0,3.368-3.164L29.25,9h-27Z',
              transform: 'translate(540 1870.554)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'trash-path-2',
              d: 'M11.722-.5h8.043A2.176,2.176,0,0,1,21.724.712l.522,1.038h8.129A1.627,1.627,0,0,1,32,3.375v2.25A1.627,1.627,0,0,1,30.375,7.25H1.125A1.627,1.627,0,0,1-.5,5.625V3.375A1.627,1.627,0,0,1,1.125,1.75H9.254L9.776.713A2.181,2.181,0,0,1,11.722-.5ZM30.375,6.25A.626.626,0,0,0,31,5.625V3.375a.626.626,0,0,0-.625-.625H21.629l-.8-1.59A1.182,1.182,0,0,0,19.766.5H11.722a1.175,1.175,0,0,0-1.049.655l0,0-.8,1.59H1.125A.626.626,0,0,0,.5,3.375v2.25a.626.626,0,0,0,.625.625ZM1.718,8.5H29.782L28.258,32.868A3.882,3.882,0,0,1,24.391,36.5H7.109a3.882,3.882,0,0,1-3.867-3.633Zm27,1H2.782L4.24,32.8a2.88,2.88,0,0,0,2.869,2.7H24.391a2.88,2.88,0,0,0,2.869-2.695Z',
              transform: 'translate(540 1870.554)',
            },
          },
        ],
      },
    ],
  },

  upload: {
    type: 'svg',
    attrs: {
      id: 'upload',
      viewBox: '0 0 34.381 34.381',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'upload-g-1',
          transform: 'translate(1.5 1.5)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'upload-path-1',
              d: 'M32.394,34.46H7.987A4.992,4.992,0,0,1,3,29.474V22.5a1.5,1.5,0,1,1,3,0v6.974A1.989,1.989,0,0,0,7.987,31.46H32.394a1.989,1.989,0,0,0,1.987-1.987V22.5a1.5,1.5,0,1,1,3,0v6.974A4.992,4.992,0,0,1,32.394,34.46Z',
              transform: 'translate(-4.5 -1.579)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'upload-path-2',
              d: 'M27.934,14.717a1.5,1.5,0,0,1-1.061-.439L19.217,6.621l-7.656,7.656a1.5,1.5,0,0,1-2.121-2.121l8.717-8.717a1.5,1.5,0,0,1,2.121,0l8.717,8.717a1.5,1.5,0,0,1-1.061,2.561Z',
              transform: 'translate(-3.526 -4.5)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'upload-path-3',
              d: 'M18,26.921a1.5,1.5,0,0,1-1.5-1.5V4.5a1.5,1.5,0,0,1,3,0V25.421A1.5,1.5,0,0,1,18,26.921Z',
              transform: 'translate(-2.31 -4.5)',
            },
          },
        ],
      },
    ],
  },

  verification: {
    type: 'svg',
    attrs: {
      id: 'verification',
      viewBox: '0 0 46.43 56.748',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'verification-path-1',
          d: 'M27.715,1.5,4.5,11.818V27.295c0,14.316,9.905,27.7,23.215,30.953C41.025,55,50.93,41.611,50.93,27.295V11.818ZM22.556,42.771,12.238,32.453l3.637-3.637,6.681,6.655,17-17,3.637,3.663Z',
          transform: 'translate(-4.5 -1.5)',
        },
      },
    ],
  },

  'wild-screen': {
    type: 'svg',
    attrs: {
      id: 'wild-screen',
      viewBox: '0 0 23 23',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'wild-screen-path-1',
          d: 'M23,23H14.785V19.713h4.928V14.785H23V23ZM8.215,23H0V14.785H3.285v4.928H8.215V23ZM23,8.215H19.713V3.285H14.785V0H23V8.215Zm-19.715,0H0V0H8.215V3.285H3.285V8.215Z',
        },
      },
    ],
  },

  website: {
    type: 'svg',
    attrs: {
      id: 'website',
      viewBox: '0 0 47.131 41.894',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'website-g-1',
          transform: 'translate(-5 -10)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'website-path-1',
              d: 'M48.989,10H8.142A3.142,3.142,0,0,0,5,13.142v35.61a3.142,3.142,0,0,0,3.142,3.142H48.989a3.142,3.142,0,0,0,3.142-3.142V13.142A3.142,3.142,0,0,0,48.989,10Zm-24,3.142A2.357,2.357,0,1,1,22.632,15.5,2.357,2.357,0,0,1,24.989,13.142Zm-6.284,0A2.357,2.357,0,1,1,16.348,15.5,2.357,2.357,0,0,1,18.7,13.142Zm-6.284,0A2.357,2.357,0,1,1,10.064,15.5a2.357,2.357,0,0,1,2.357-2.357Zm35,33.515a.524.524,0,0,1-.524.524H10.237a.524.524,0,0,1-.524-.524V21.521A.524.524,0,0,1,10.237,21H46.894a.524.524,0,0,1,.524.524Z',
            },
          },
          {
            type: 'rect',
            attrs: {
              id: 'website-rect-1',
              width: '12',
              height: '9',
              rx: '1',
              transform: 'translate(13 24)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'website-path-2',
              d: 'M64.139,38H51.571a1.571,1.571,0,1,0,0,3.142H64.139a1.571,1.571,0,0,0,0-3.142Z',
              transform: 'translate(-21.435 -13.337)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'website-path-3',
              d: 'M61,50.142A1.571,1.571,0,1,0,61,47H51.571a1.571,1.571,0,1,0,0,3.142Z',
              transform: 'translate(-21.435 -17.624)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'website-path-4',
              d: 'M49.85,60H21.571a1.571,1.571,0,1,0,0,3.142H49.85a1.571,1.571,0,0,0,0-3.142Z',
              transform: 'translate(-7.145 -23.816)',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'website-path-5',
              d: 'M45.136,69H21.571a1.571,1.571,0,0,0,0,3.142H45.136a1.571,1.571,0,1,0,0-3.142Z',
              transform: 'translate(-7.145 -28.103)',
            },
          },
        ],
      },
    ],
  },

  'circle-plus': {
    type: 'svg',
    attrs: {
      id: 'circle-plus',
      viewBox: '0 0 22 23',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'circle-plus-g-1',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'circle-plus-path-1',
              d: 'M16.5 10.7079H11.4783V6H10.5217V10.7079H5.5V11.6046H10.5217V16.3125H11.4783V11.6046H16.5V10.7079Z',
            },
          },
          {
            type: 'circle',
            attrs: {
              id: 'circle-plus-circle-1',
              cx: '11',
              cy: '11.5',
              r: '10.5',
              fill: 'none',
              stroke: 'black',
            },
          },
        ],
      },
    ],
  },
  location: {
    type: 'svg',
    attrs: {
      id: 'location',
      viewBox: '0 0 22 26',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'location-path-1',
          d: 'M20.942 6.53373C20.3957 5.27401 19.608 4.13344 18.6234 3.17637C17.6357 2.21065 16.4712 1.44417 15.1935 0.918778C13.8645 0.367439 12.4542 0.0888672 11.0005 0.0888672C9.54666 0.0888672 8.13639 0.367439 6.80737 0.915876C5.52188 1.4469 4.36987 2.20717 3.37746 3.17347C2.39353 4.13107 1.60597 5.27151 1.05894 6.53083C0.493087 7.83663 0.205811 9.22369 0.205811 10.6514C0.205811 12.7 0.696213 14.74 1.65961 16.7074C2.43438 18.2889 3.51675 19.8297 4.88059 21.2951C7.21072 23.7965 9.65403 25.3257 10.3476 25.7348C10.5444 25.8511 10.7689 25.9123 10.9976 25.9119C11.2239 25.9119 11.4473 25.8538 11.6476 25.7348C12.3411 25.3257 14.7844 23.7965 17.1145 21.2951C18.4784 19.8326 19.5607 18.2889 20.3355 16.7074C21.3047 14.7429 21.7951 12.7058 21.7951 10.6543C21.7951 9.22659 21.5078 7.83954 20.942 6.53373ZM11.0005 23.6862C9.08818 22.4703 2.2951 17.6563 2.2951 10.6543C2.2951 8.39378 3.19755 6.26967 4.83706 4.66788C6.48237 3.0632 8.67032 2.17815 11.0005 2.17815C13.3306 2.17815 15.5185 3.0632 17.1638 4.67079C18.8034 6.26967 19.7058 8.39378 19.7058 10.6543C19.7058 17.6563 12.9127 22.4703 11.0005 23.6862ZM11.0005 5.77637C8.17992 5.77637 5.89331 8.06297 5.89331 10.8835C5.89331 13.704 8.17992 15.9907 11.0005 15.9907C13.821 15.9907 16.1076 13.704 16.1076 10.8835C16.1076 8.06297 13.821 5.77637 11.0005 5.77637ZM13.2987 13.1817C12.9972 13.484 12.639 13.7237 12.2446 13.8871C11.8502 14.0504 11.4274 14.1342 11.0005 14.1335C10.1328 14.1335 9.31742 13.794 8.70224 13.1817C8.39994 12.8803 8.16023 12.5221 7.99688 12.1276C7.83354 11.7332 7.74979 11.3104 7.75045 10.8835C7.75045 10.0159 8.08996 9.20047 8.70224 8.58529C9.31742 7.97012 10.1328 7.63351 11.0005 7.63351C11.8681 7.63351 12.6835 7.97012 13.2987 8.58529C13.9138 9.20047 14.2505 10.0159 14.2505 10.8835C14.2505 11.7511 13.9138 12.5665 13.2987 13.1817Z',
        },
      },
    ],
  },
  phone: {
    type: 'svg',
    attrs: {
      id: 'phone',
      viewBox: '0 0 24 24',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'phone-path-1',
          d: 'M21.7799 4.68269L18.9272 1.83269C18.579 1.48448 18.1129 1.28894 17.6201 1.28894C17.1272 1.28894 16.6611 1.4818 16.3129 1.83269L13.2406 4.89966C12.8924 5.24787 12.6968 5.71662 12.6968 6.20948C12.6968 6.70501 12.8897 7.16841 13.2406 7.5193L15.6406 9.92198C15.0939 11.1959 14.3083 12.3533 13.3263 13.3318C12.3433 14.3202 11.1942 15.0997 9.91917 15.6514L7.51917 13.2488C7.17096 12.9005 6.70488 12.705 6.21203 12.705C5.96893 12.7041 5.72809 12.7517 5.50364 12.8451C5.27918 12.9385 5.07562 13.0757 4.90488 13.2488L1.82988 16.3157C1.48167 16.6639 1.28613 17.1327 1.28613 17.6255C1.28613 18.1211 1.47899 18.5845 1.82988 18.9354L4.67988 21.7854C5.27453 22.38 6.09417 22.7202 6.93524 22.7202C7.10935 22.7202 7.2781 22.7068 7.44953 22.6773C10.996 22.0934 14.5156 20.205 17.3576 17.3657C20.1968 14.5211 22.0826 11.0014 22.6719 7.45233C22.8406 6.44519 22.5031 5.40858 21.7799 4.68269ZM20.7727 7.13358C20.2504 10.2916 18.5522 13.4416 15.9942 15.9997C13.4361 18.5577 10.2888 20.2559 7.13078 20.7782C6.73435 20.8452 6.3272 20.7113 6.03792 20.4247L3.23881 17.6255L6.20667 14.655L9.4156 17.8693L9.4397 17.8934L10.0183 17.6791C11.7725 17.0341 13.3656 16.0154 14.687 14.6935C16.0084 13.3717 17.0266 11.7783 17.671 10.0238L17.8852 9.44519L14.6495 6.21215L17.6174 3.24162L20.4165 6.04073C20.7058 6.33001 20.8397 6.73716 20.7727 7.13358Z',
        },
      },
    ],
  },
  mail: {
    type: 'svg',
    attrs: {
      id: 'mail',
      viewBox: '0 0 23 23',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'mail-g-1',
          clipPath: 'url(#mail-clipPath-1)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'mail-path-1',
              d: 'M22.1786 2.45959H0.821429C0.367076 2.45959 0 2.82667 0 3.28102V19.7096C0 20.1639 0.367076 20.531 0.821429 20.531H22.1786C22.6329 20.531 23 20.1639 23 19.7096V3.28102C23 2.82667 22.6329 2.45959 22.1786 2.45959ZM21.1518 5.30379V18.6828H1.84821V5.30379L1.13973 4.75189L2.14855 3.45558L3.24721 4.31038H19.7554L20.854 3.45558L21.8628 4.75189L21.1518 5.30379ZM19.7554 4.30781L11.5 10.7252L3.24464 4.30781L2.14598 3.45301L1.13717 4.74933L1.84565 5.30122L10.6144 12.1191C10.8666 12.315 11.1768 12.4213 11.4962 12.4213C11.8155 12.4213 12.1257 12.315 12.3779 12.1191L21.1518 5.30379L21.8603 4.75189L20.8515 3.45558L19.7554 4.30781Z',
            },
          },
        ],
      },
      {
        type: 'defs',
        attrs: {
          id: 'mail-defs-1',
        },
        childs: [
          {
            type: 'clipPath',
            attrs: {
              id: 'mail-clipPath-1',
            },
            childs: [
              {
                type: 'rect',
                attrs: {
                  id: 'mail-rect-1',
                  width: 23,
                  height: 23,
                  fill: 'white',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  idea: {
    type: 'svg',
    attrs: {
      id: 'idea',
      viewBox: '0 0 23 22',
    },
    childs: [
      {
        type: 'g',
        attrs: {
          id: 'idea-g-1',
          clipPath: 'url(#idea-clipPath-1)',
        },
        childs: [
          {
            type: 'path',
            attrs: {
              id: 'idea-path-1',
              d: 'M0.557129 11.5378H3.30713V12.5078H0.557129V11.5378Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-2',
              d: 'M0.307129 12.7504H3.55713V11.2954H0.307129V12.7504ZM3.05713 12.2654H0.807129V11.7804H3.05713V12.2654Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-3',
              d: 'M19.3071 11.5378H22.0571V12.5078H19.3071V11.5378Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-4',
              d: 'M19.0571 12.7504H22.3071V11.2954H19.0571V12.7504ZM21.8071 12.2654H19.5571V11.7804H21.8071V12.2654Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-5',
              d: 'M10.8071 0.96521H11.8071V3.48715H10.8071V0.96521Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-6',
              d: 'M10.5571 3.72958H12.0571V0.722656H10.5571V3.72958ZM11.5571 3.2446H11.0571V1.20764H11.5571V3.2446Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-7',
              d: 'M4.32485 3.55913L6.16333 5.34241L5.45622 6.02828L3.61775 4.245L4.32485 3.55913Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-8',
              d: 'M5.45465 6.3703L6.51465 5.34213L4.32215 3.21545L3.26215 4.24363L5.45465 6.3703ZM5.80715 5.34213L5.45465 5.68405L3.96965 4.24363L4.32215 3.90171L5.80715 5.34213Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-9',
              d: 'M17.1586 16.9983L18.9971 18.7816L18.29 19.4675L16.4515 17.6842L17.1586 16.9983Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-10',
              d: 'M18.2921 19.8118L19.3521 18.7837L17.1596 16.657L16.0996 17.6852L18.2921 19.8118ZM18.6446 18.7837L18.2921 19.1256L16.8071 17.6852L17.1596 17.3408L18.6446 18.7812V18.7837Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-11',
              d: 'M18.2995 3.56864L19.0066 4.25452L17.1681 6.0378L16.461 5.35192L18.2995 3.56864Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-12',
              d: 'M17.1696 6.38007L19.3621 4.2534L18.3021 3.22522L16.1096 5.35189L17.1696 6.38007ZM18.6546 4.2534L17.1696 5.69381L16.8171 5.35189L18.3021 3.91148L18.6546 4.2534Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-13',
              d: 'M5.4467 16.9888L6.15381 17.6747L4.31533 19.458L3.60822 18.7721L5.4467 16.9888Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-14',
              d: 'M4.31458 19.8021L6.50708 17.6754L5.44708 16.6472L3.25458 18.7739L4.31458 19.8021ZM5.79958 17.6754L4.31458 19.1158L3.96208 18.7739L5.44708 17.3335L5.79958 17.6778V17.6754Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-15',
              d: 'M8.0572 20.5102V18.3277C8.0572 17.6488 7.7072 17.0183 7.0322 16.4848C5.4572 15.2481 4.5572 13.4294 4.5572 11.4652C4.5572 9.6707 5.3072 7.99749 6.6572 6.76077C8.0322 5.4998 9.8322 4.86931 11.7322 4.99056C15.1072 5.18456 17.8822 7.90049 18.0322 11.1742C18.1322 13.2596 17.2072 15.1996 15.5322 16.509C15.0822 16.8728 14.5322 17.4548 14.5322 18.3277V20.5102C14.5322 21.0679 14.1072 21.4802 13.5572 21.4802H9.0072C8.4822 21.4802 8.0572 21.0679 8.0572 20.5102ZM9.0572 20.5102H13.5572V20.2677H9.0572V20.5102ZM9.0572 19.2977H13.5572V19.0552H9.0572V19.2977ZM13.5822 18.061C13.6572 17.188 14.1322 16.3878 14.9322 15.7573C16.3572 14.6418 17.1322 12.9929 17.0572 11.2227C16.9322 8.45823 14.5572 6.15453 11.6822 5.96054C10.0572 5.86354 8.5322 6.39703 7.3572 7.464C6.2072 8.50673 5.5572 9.93744 5.5572 11.4652C5.5572 13.1141 6.3322 14.6661 7.6572 15.7331C8.4822 16.3878 8.9572 17.188 9.0322 18.061H13.5822Z',
            },
          },
          {
            type: 'path',
            attrs: {
              id: 'idea-path-16',
              d: 'M9.00724 21.7227H13.5572C14.2547 21.7227 14.7822 21.2013 14.7822 20.5102V18.3277C14.7822 17.7239 15.0797 17.1904 15.6922 16.6958C17.4397 15.3305 18.3847 13.313 18.2822 11.1645C18.1272 7.76955 15.2572 4.95176 11.7472 4.75049C9.78474 4.6244 7.91474 5.27671 6.48474 6.58617C5.07974 7.87382 4.30724 9.60523 4.30724 11.4676C4.30724 13.4973 5.24224 15.3936 6.87474 16.6764C7.49224 17.1662 7.80724 17.7215 7.80724 18.3302V20.5126C7.80724 21.1916 8.33474 21.7251 9.00724 21.7251V21.7227ZM11.2722 5.21851C11.4197 5.21851 11.5672 5.22336 11.7147 5.23306C14.9722 5.41978 17.6372 8.03386 17.7822 11.1863C17.8772 13.1796 16.9997 15.0516 15.3747 16.3223C14.6372 16.9189 14.2822 17.5736 14.2822 18.3302V20.5126C14.2822 20.9346 13.9772 21.2401 13.5572 21.2401H9.00724C8.60724 21.2401 8.30724 20.9273 8.30724 20.5126V18.3302C8.30724 17.5784 7.92224 16.8776 7.18974 16.2981C5.67474 15.1098 4.80724 13.3469 4.80724 11.4676C4.80724 9.74102 5.52474 8.13329 6.82974 6.94022C8.04724 5.82232 9.61224 5.22093 11.2747 5.22093L11.2722 5.21851ZM8.80724 20.7527H13.8072V20.0252H8.80724V20.7527ZM8.80724 19.5402H13.8072V18.8127H8.80724V19.5402ZM8.80224 18.3035H13.8122L13.8322 18.0804C13.9022 17.2777 14.3372 16.5406 15.0897 15.944C16.5772 14.7801 17.3847 13.0559 17.3072 11.2105C17.1772 8.33213 14.7147 5.91931 11.6997 5.71562C10.0122 5.61377 8.41224 6.17151 7.18724 7.28456C5.97474 8.38306 5.30724 9.86712 5.30724 11.4627C5.30724 13.1723 6.10474 14.797 7.49724 15.9174C8.26974 16.5309 8.71474 17.2777 8.78224 18.078L8.80224 18.3011V18.3035ZM13.3597 17.8185H9.25224C9.11724 16.9698 8.62224 16.1865 7.81474 15.5463C6.53974 14.5182 5.80724 13.0317 5.80724 11.4652C5.80724 10.0053 6.41724 8.64737 7.52724 7.64102C8.64974 6.62012 10.1197 6.11089 11.6672 6.20303C14.4297 6.38975 16.6897 8.59888 16.8072 11.2348C16.8797 12.9225 16.1372 14.5036 14.7747 15.5706C13.9797 16.1962 13.4947 16.9698 13.3597 17.8209V17.8185Z',
            },
          },
        ],
      },
      {
        type: 'defs',
        attrs: {
          id: 'idea-defs-1',
        },
        childs: [
          {
            type: 'clipPath',
            attrs: {
              id: 'idea-clipPath-1',
            },
            childs: [
              {
                type: 'rect',
                attrs: {
                  id: 'idea-rect-1',
                  width: 22,
                  height: 21,
                  transform: 'matrix(-1 0 0 1 22.3071 0.722656)',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  optout: {
    type: 'svg',
    attrs: {
      id: 'optout',
      viewBox: '0 0 17 16',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'optout-path-1',
          d: 'M15.8667 13.1502H14.7859C14.7015 13.1502 14.6312 13.2205 14.6312 13.3049V14.5464H1.98094V1.89415H14.6332V3.13567C14.6332 3.22004 14.7035 3.29036 14.7879 3.29036H15.8687C15.953 3.29036 16.0234 3.22205 16.0234 3.13567V1.12272C16.0234 0.781205 15.7481 0.505981 15.4066 0.505981H1.20951C0.867997 0.505981 0.592773 0.781205 0.592773 1.12272V15.3178C0.592773 15.6593 0.867997 15.9346 1.20951 15.9346H15.4046C15.7461 15.9346 16.0213 15.6593 16.0213 15.3178V13.3049C16.0213 13.2185 15.951 13.1502 15.8667 13.1502ZM16.2403 8.09371L13.3897 5.84371C13.2832 5.75933 13.1285 5.83567 13.1285 5.97027V7.49705H6.82045C6.73206 7.49705 6.65974 7.56938 6.65974 7.65777V8.78277C6.65974 8.87116 6.73206 8.94348 6.82045 8.94348H13.1285V10.4703C13.1285 10.6049 13.2852 10.6812 13.3897 10.5968L16.2403 8.34683C16.2595 8.3318 16.2751 8.31259 16.2857 8.29066C16.2964 8.26873 16.302 8.24466 16.302 8.22027C16.302 8.19588 16.2964 8.1718 16.2857 8.14988C16.2751 8.12795 16.2595 8.10874 16.2403 8.09371Z',
        },
      },
    ],
  },
  optin: {
    type: 'svg',
    attrs: {
      id: 'optin',
      viewBox: '0 0 15 14',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'optin-path-1',
          d: 'M13.7194 11.38H12.7587C12.6837 11.38 12.6212 11.4425 12.6212 11.5175V12.6211H1.37651V1.37468H12.6229V2.47825C12.6229 2.55325 12.6854 2.61575 12.7604 2.61575H13.7212C13.7962 2.61575 13.8587 2.55503 13.8587 2.47825V0.688961C13.8587 0.38539 13.614 0.140747 13.3104 0.140747H0.690793C0.387221 0.140747 0.142578 0.38539 0.142578 0.688961V13.3068C0.142578 13.6104 0.387221 13.855 0.690793 13.855H13.3087C13.6122 13.855 13.8569 13.6104 13.8569 13.3068V11.5175C13.8569 11.4407 13.7944 11.38 13.7194 11.38ZM13.964 6.35503H8.35687V4.99789C8.35687 4.87825 8.21758 4.81039 8.12472 4.88539L5.59079 6.88539C5.57372 6.89875 5.55991 6.91583 5.55041 6.93532C5.54092 6.95481 5.53598 6.97621 5.53598 6.99789C5.53598 7.01957 5.54092 7.04097 5.55041 7.06046C5.55991 7.07995 5.57372 7.09703 5.59079 7.11039L8.12472 9.11039C8.21937 9.18539 8.35687 9.11753 8.35687 8.99789V7.64075H13.964C14.0426 7.64075 14.1069 7.57646 14.1069 7.49789V6.49789C14.1069 6.41932 14.0426 6.35503 13.964 6.35503Z',
        },
      },
    ],
  },
  tracking: {
    type: 'svg',
    attrs: {
      id: 'tracking',
      viewBox: '0 0 13 12',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'tracking-path-1',
          d: 'M12.7738 5.64886H11.0008C10.7498 3.52475 9.06534 1.84026 6.94123 1.58926V-0.183733C6.94123 -0.247573 6.889 -0.299805 6.82516 -0.299805H5.95462C5.89079 -0.299805 5.83855 -0.247573 5.83855 -0.183733V1.58926C3.71445 1.84026 2.02996 3.52475 1.77895 5.64886H0.005964C-0.0578753 5.64886 -0.110107 5.70109 -0.110107 5.76493V6.63546C-0.110107 6.6993 -0.0578753 6.75153 0.005964 6.75153H1.77895C2.02996 8.87564 3.71445 10.5601 5.83855 10.8111V12.5841C5.83855 12.648 5.89079 12.7002 5.95462 12.7002H6.82516C6.889 12.7002 6.94123 12.648 6.94123 12.5841V10.8111C9.06534 10.5601 10.7498 8.87564 11.0008 6.75153H12.7738C12.8377 6.75153 12.8899 6.6993 12.8899 6.63546V5.76493C12.8899 5.70109 12.8377 5.64886 12.7738 5.64886ZM6.38989 9.74037C4.43409 9.74037 2.84971 8.156 2.84971 6.2002C2.84971 4.24439 4.43409 2.66002 6.38989 2.66002C8.3457 2.66002 9.93007 4.24439 9.93007 6.2002C9.93007 8.156 8.3457 9.74037 6.38989 9.74037Z',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'tracking-path-2',
          d: 'M6.39011 4.4609C5.92438 4.4609 5.48911 4.64081 5.15976 4.97162C4.8304 5.30097 4.64904 5.73624 4.64904 6.20197C4.64904 6.66771 4.8304 7.10298 5.15976 7.43233C5.48911 7.76023 5.92583 7.94304 6.39011 7.94304C6.8544 7.94304 7.29112 7.76168 7.62047 7.43233C7.94837 7.10298 8.13118 6.66626 8.13118 6.20197C8.13118 5.73769 7.94982 5.30097 7.62047 4.97162C7.45964 4.80897 7.26799 4.68003 7.05673 4.59233C6.84547 4.50464 6.61885 4.45996 6.39011 4.4609Z',
        },
      },
    ],
  },
  cursor: {
    type: 'svg',
    attrs: {
      id: 'cursor',
      viewBox: '0 0 12 12',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'cursor-path-1',
          d: 'M8.0185 5.93378L10.0286 4.81868C10.1281 4.76307 10.1866 4.65478 10.1778 4.54064C10.169 4.4265 10.0959 4.32991 9.99056 4.28894L1.39718 1.01975C1.28893 0.978774 1.16604 1.00219 1.08411 1.08414C1.00219 1.16609 0.97878 1.28901 1.01974 1.3973L4.2909 9.99612C4.33187 10.1015 4.43135 10.1747 4.54253 10.1834C4.65664 10.1922 4.7649 10.1337 4.82049 10.0342L5.93526 8.02349L8.82605 10.9151C8.88457 10.9737 8.95772 11 9.03379 11C9.10987 11 9.18301 10.9707 9.24153 10.9151L10.9151 9.24102C10.9707 9.18541 11 9.11224 11 9.03322C11 8.9542 10.9678 8.88103 10.9151 8.82542L8.02435 5.93378H8.0185ZM9.03087 10.2917L6.07278 7.33277C6.01719 7.27716 5.94404 7.24789 5.86504 7.24789C5.85041 7.24789 5.83871 7.24789 5.82408 7.24789C5.73337 7.2596 5.65437 7.31521 5.60756 7.39423L4.60983 9.19419L1.79803 1.79827L9.19472 4.61381L7.39529 5.61184C7.31629 5.65574 7.26069 5.73476 7.24899 5.82842C7.23729 5.91915 7.26655 6.00987 7.33092 6.07719L10.289 9.03614L9.03087 10.2947V10.2917Z',
        },
      },
    ],
  },
  flags: {
    type: 'svg',
    attrs: {
      id: 'flags',
      viewBox: '0 0 12 12',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'flags-path-1',
          d: 'M10.9288 3.22935H7.50021V1.71596C7.50021 1.47891 7.30869 1.28739 7.07164 1.28739H1.60735V0.751674C1.60735 0.692746 1.55914 0.644531 1.50021 0.644531H0.750209C0.691281 0.644531 0.643066 0.692746 0.643066 0.751674V11.2517C0.643066 11.3106 0.691281 11.3588 0.750209 11.3588H1.50021C1.55914 11.3588 1.60735 11.3106 1.60735 11.2517V7.71596H4.92878V9.22935C4.92878 9.46641 5.1203 9.65792 5.35735 9.65792H10.9288C11.1658 9.65792 11.3574 9.46641 11.3574 9.22935V3.65792C11.3574 3.42087 11.1658 3.22935 10.9288 3.22935ZM1.60735 6.75167V2.25167H6.53592V6.75167H1.60735ZM10.3931 8.69364H5.89307V7.71596H7.39307C7.452 7.71596 7.50021 7.66775 7.50021 7.60882V4.19364H10.3931V8.69364Z',
        },
      },
    ],
  },
  playCircle: {
    type: 'svg',
    attrs: {
      id: 'playCircle',
      viewBox: '0 0 15 15',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'playCircle-path-1',
          d: 'M6.01468 3.68431L10.9717 7.28364C11.0059 7.3083 11.0338 7.34075 11.053 7.37829C11.0723 7.41584 11.0823 7.45742 11.0823 7.4996C11.0823 7.54179 11.0723 7.58337 11.053 7.62091C11.0338 7.65846 11.0059 7.6909 10.9717 7.71556L6.01468 11.3149C5.8389 11.4421 5.59113 11.3182 5.59113 11.0989V3.90027C5.59089 3.85098 5.60435 3.80259 5.63 3.76049C5.65565 3.7184 5.69248 3.68425 5.7364 3.66186C5.78031 3.63947 5.82958 3.62971 5.87872 3.63367C5.92785 3.63764 5.97492 3.65517 6.01468 3.68431ZM6.65921 5.47226V9.52695L9.44995 7.4996L6.65921 5.47226Z',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'playCircle-path-2',
          d: 'M0 7.5C0 3.35826 3.35826 0 7.5 0C11.6417 0 15 3.35826 15 7.5C15 11.6417 11.6417 15 7.5 15C3.35826 15 0 11.6417 0 7.5ZM1.27232 7.5C1.27232 10.9386 4.06138 13.7277 7.5 13.7277C10.9386 13.7277 13.7277 10.9386 13.7277 7.5C13.7277 4.06138 10.9386 1.27232 7.5 1.27232C4.06138 1.27232 1.27232 4.06138 1.27232 7.5Z',
        },
      },
    ],
  },
  eye: {
    type: 'svg',
    attrs: {
      id: 'eye',
      viewBox: '0 0 16 16',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'eye-path-1',
          d: 'M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'eye-path-2',
          d: 'M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z',
        },
      },
    ],
  },
  plus: {
    type: 'svg',
    attrs: {
      id: 'plus',
      viewBox: '0 0 28 30',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'plus-path-1',
          d: 'M15.205 0.537598H12.7943C12.58 0.537598 12.4729 0.644741 12.4729 0.859026V13.4751H0.500628C0.286342 13.4751 0.179199 13.5822 0.179199 13.7965V16.2072C0.179199 16.4215 0.286342 16.5287 0.500628 16.5287H12.4729V29.1447C12.4729 29.359 12.58 29.4662 12.7943 29.4662H15.205C15.4193 29.4662 15.5265 29.359 15.5265 29.1447V16.5287H27.5006C27.7149 16.5287 27.8221 16.4215 27.8221 16.2072V13.7965C27.8221 13.5822 27.7149 13.4751 27.5006 13.4751H15.5265V0.859026C15.5265 0.644741 15.4193 0.537598 15.205 0.537598Z',
        },
      },
    ],
  },
  close: {
    type: 'svg',
    attrs: {
      id: 'close',
      viewBox: '0 0 26 28',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'close-path-1',
          d: 'M15.0807 13.9982L25.6275 1.42629C25.8043 1.21737 25.6557 0.899955 25.3824 0.899955H22.1762C21.9874 0.899955 21.8066 0.98433 21.682 1.12897L12.9833 11.4991L4.28468 1.12897C4.16414 0.98433 3.98334 0.899955 3.79048 0.899955H0.584232C0.311018 0.899955 0.162357 1.21737 0.339143 1.42629L10.886 13.9982L0.339143 26.57C0.299541 26.6166 0.274135 26.6736 0.26594 26.7341C0.257745 26.7947 0.267106 26.8564 0.292911 26.9118C0.318716 26.9672 0.359882 27.0141 0.411521 27.0468C0.46316 27.0795 0.523102 27.0967 0.584232 27.0964H3.79048C3.97932 27.0964 4.16013 27.012 4.28468 26.8674L12.9833 16.4973L21.682 26.8674C21.8025 27.012 21.9833 27.0964 22.1762 27.0964H25.3824C25.6557 27.0964 25.8043 26.779 25.6275 26.57L15.0807 13.9982Z',
        },
      },
    ],
  },
  arrowRight: {
    type: 'svg',
    attrs: {
      id: 'arrowRight',
      viewBox: '0 0 30 30',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'arrowRight-path-1',
          d: 'M29.3441 14.0271L14.1646 0.852527C14.0481 0.752081 13.8994 0.695831 13.7427 0.695831H10.1869C9.8896 0.695831 9.75299 1.06547 9.97799 1.25833L24.0485 13.4726H0.536028C0.359242 13.4726 0.2146 13.6173 0.2146 13.794V16.2048C0.2146 16.3815 0.359242 16.5262 0.536028 16.5262H24.0445L9.97398 28.7405C9.74897 28.9374 9.88558 29.303 10.1829 29.303H13.8592C13.9356 29.303 14.0119 29.2749 14.0682 29.2226L29.3441 15.9717C29.4832 15.8508 29.5947 15.7014 29.6711 15.5336C29.7475 15.3659 29.7871 15.1837 29.7871 14.9994C29.7871 14.8151 29.7475 14.6329 29.6711 14.4652C29.5947 14.2974 29.4832 14.148 29.3441 14.0271Z',
        },
      },
    ],
  },
  plusCircle: {
    type: 'svg',
    attrs: {
      id: 'plusCircle',
      viewBox: '0 0 36 36',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'plusCircle-path-1',
          d: 'M25.3925 16.7162H19.2854V10.609C19.2854 10.4322 19.1408 10.2876 18.964 10.2876H17.0354C16.8586 10.2876 16.714 10.4322 16.714 10.609V16.7162H10.6068C10.43 16.7162 10.2854 16.8608 10.2854 17.0376V18.9662C10.2854 19.143 10.43 19.2876 10.6068 19.2876H16.714V25.3947C16.714 25.5715 16.8586 25.7162 17.0354 25.7162H18.964C19.1408 25.7162 19.2854 25.5715 19.2854 25.3947V19.2876H25.3925C25.5693 19.2876 25.714 19.143 25.714 18.9662V17.0376C25.714 16.8608 25.5693 16.7162 25.3925 16.7162Z',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'plusCircle-path-2',
          d: 'M18 0C8.05982 0 0 8.05982 0 18C0 27.9402 8.05982 36 18 36C27.9402 36 36 27.9402 36 18C36 8.05982 27.9402 0 18 0ZM18 32.9464C9.74732 32.9464 3.05357 26.2527 3.05357 18C3.05357 9.74732 9.74732 3.05357 18 3.05357C26.2527 3.05357 32.9464 9.74732 32.9464 18C32.9464 26.2527 26.2527 32.9464 18 32.9464Z',
        },
      },
    ],
  },
  'plusCircle-filled': {
    type: 'svg',
    attrs: {
      id: 'plusCircle-filled',
      viewBox: '0 0 32 32',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'plusCircle-filled-path-1',
          d: 'M16 0.25C7.30234 0.25 0.25 7.30234 0.25 16C0.25 24.6977 7.30234 31.75 16 31.75C24.6977 31.75 31.75 24.6977 31.75 16C31.75 7.30234 24.6977 0.25 16 0.25ZM22.75 16.8438C22.75 16.9984 22.6234 17.125 22.4688 17.125H17.125V22.4688C17.125 22.6234 16.9984 22.75 16.8438 22.75H15.1562C15.0016 22.75 14.875 22.6234 14.875 22.4688V17.125H9.53125C9.37656 17.125 9.25 16.9984 9.25 16.8438V15.1562C9.25 15.0016 9.37656 14.875 9.53125 14.875H14.875V9.53125C14.875 9.37656 15.0016 9.25 15.1562 9.25H16.8438C16.9984 9.25 17.125 9.37656 17.125 9.53125V14.875H22.4688C22.6234 14.875 22.75 15.0016 22.75 15.1562V16.8438Z',
        },
      },
    ],
  },
  closeCircle: {
    type: 'svg',
    attrs: {
      id: 'closeCircle',
      viewBox: '0 0 36 36',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'closeCircle-path-1',
          d: 'M24.9664 11.6461C24.9664 11.4694 24.8218 11.3247 24.645 11.3247L21.9932 11.3368L17.9994 16.0979L14.0097 11.3408L11.3539 11.3287C11.1771 11.3287 11.0325 11.4694 11.0325 11.6502C11.0325 11.7265 11.0606 11.7988 11.1088 11.8591L16.336 18.0868L11.1088 24.3104C11.0603 24.3693 11.0333 24.443 11.0325 24.5194C11.0325 24.6961 11.1771 24.8408 11.3539 24.8408L14.0097 24.8287L17.9994 20.0676L21.9892 24.8247L24.641 24.8368C24.8177 24.8368 24.9624 24.6961 24.9624 24.5153C24.9624 24.439 24.9343 24.3667 24.886 24.3064L19.6668 18.0827L24.8941 11.8551C24.9423 11.7988 24.9664 11.7225 24.9664 11.6461Z',
        },
      },
      {
        type: 'path',
        attrs: {
          id: 'closeCircle-path-2',
          d: 'M18 0C8.05982 0 0 8.05982 0 18C0 27.9402 8.05982 36 18 36C27.9402 36 36 27.9402 36 18C36 8.05982 27.9402 0 18 0ZM18 32.9464C9.74732 32.9464 3.05357 26.2527 3.05357 18C3.05357 9.74732 9.74732 3.05357 18 3.05357C26.2527 3.05357 32.9464 9.74732 32.9464 18C32.9464 26.2527 26.2527 32.9464 18 32.9464Z',
        },
      },
    ],
  },
  'closeCircle-filled': {
    type: 'svg',
    attrs: {
      id: 'closeCircle-filled',
      viewBox: '0 0 32 32',
    },
    childs: [
      {
        type: 'path',
        attrs: {
          id: 'closeCircle-filled-path-1',
          d: 'M16 0.25C7.30234 0.25 0.25 7.30234 0.25 16C0.25 24.6977 7.30234 31.75 16 31.75C24.6977 31.75 31.75 24.6977 31.75 16C31.75 7.30234 24.6977 0.25 16 0.25ZM21.8148 21.9836L19.4945 21.973L16 17.807L12.509 21.9695L10.1852 21.9801C10.0305 21.9801 9.90391 21.857 9.90391 21.6988C9.90391 21.632 9.92852 21.5688 9.9707 21.516L14.5445 16.0668L9.9707 10.6211C9.92822 10.5696 9.90465 10.5051 9.90391 10.4383C9.90391 10.2836 10.0305 10.157 10.1852 10.157L12.509 10.1676L16 14.3336L19.491 10.1711L21.8113 10.1605C21.966 10.1605 22.0926 10.2836 22.0926 10.4418C22.0926 10.5086 22.068 10.5719 22.0258 10.6246L17.459 16.0703L22.0293 21.5195C22.0715 21.5723 22.0961 21.6355 22.0961 21.7023C22.0961 21.857 21.9695 21.9836 21.8148 21.9836Z',
        },
      },
    ],
  },
};
